/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var SUCCESS_MESSAGE = 'Event tracked successfully';
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Event rejected due to exceeded retry count';
var OPT_OUT_MESSAGE = 'Event skipped due to optOut config';
var MISSING_API_KEY_MESSAGE = 'Event rejected due to missing API key';
var INVALID_API_KEY = 'Invalid API key';
var CLIENT_NOT_INITIALIZED = 'Client not initialized';

var IdentifyOperation;
(function (IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));
var RevenueProperty;
(function (RevenueProperty) {
    RevenueProperty["REVENUE_PRODUCT_ID"] = "$productId";
    RevenueProperty["REVENUE_QUANTITY"] = "$quantity";
    RevenueProperty["REVENUE_PRICE"] = "$price";
    RevenueProperty["REVENUE_TYPE"] = "$revenueType";
    RevenueProperty["REVENUE"] = "$revenue";
})(RevenueProperty || (RevenueProperty = {}));
/**
 * Strings that have special meaning when used as an event's type
 * and have different specifications.
 */
var SpecialEventType;
(function (SpecialEventType) {
    SpecialEventType["IDENTIFY"] = "$identify";
    SpecialEventType["GROUP_IDENTIFY"] = "$groupidentify";
    SpecialEventType["REVENUE"] = "revenue_amount";
})(SpecialEventType || (SpecialEventType = {}));

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));

/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent successfully. */
    Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */
    Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */
    Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */
    Status["SystemError"] = "SystemError";
})(Status || (Status = {}));

var OfflineDisabled = null;

var buildResult = function (event, code, message) {
    if (code === void 0) { code = 0; }
    if (message === void 0) { message = Status.Unknown; }
    return { event: event, code: code, message: message };
};

/**
 * Source: [jed's gist]{@link https://gist.github.com/982883}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */
var UUID = function (a) {
    return a // if the placeholder was passed, return
        ? // a random number from 0 to 15
            (a ^ // unless b is 8,
                ((Math.random() * // in which case
                    16) >> // a random number from
                    (a / 4))) // 8 to 11
                .toString(16) // in hexadecimal
        : // or otherwise a concatenated string:
            (String(1e7) + // 10000000 +
                String(-1e3) + // -1000 +
                String(-4e3) + // -4000 +
                String(-8e3) + // -80000000 +
                String(-1e11)) // -100000000000,
                .replace(
            // replacing
            /[018]/g, // zeroes, ones, and eights with
            UUID);
};

var Timeline = /** @class */ (function () {
    function Timeline(client) {
        this.client = client;
        this.queue = [];
        // Flag to guarantee one schedule apply is running
        this.applying = false;
        // Flag indicates whether timeline is ready to process event
        // Events collected before timeline is ready will stay in the queue to be processed later
        this.plugins = [];
    }
    Timeline.prototype.register = function (plugin, config) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        plugin.name = (_a = plugin.name) !== null && _a !== void 0 ? _a : UUID();
                        plugin.type = (_b = plugin.type) !== null && _b !== void 0 ? _b : 'enrichment';
                        return [4 /*yield*/, ((_c = plugin.setup) === null || _c === void 0 ? void 0 : _c.call(plugin, config, this.client))];
                    case 1:
                        _d.sent();
                        this.plugins.push(plugin);
                        return [2 /*return*/];
                }
            });
        });
    };
    Timeline.prototype.deregister = function (pluginName) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var index, plugin;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        index = this.plugins.findIndex(function (plugin) { return plugin.name === pluginName; });
                        plugin = this.plugins[index];
                        this.plugins.splice(index, 1);
                        return [4 /*yield*/, ((_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Timeline.prototype.reset = function (client) {
        this.applying = false;
        var plugins = this.plugins;
        plugins.map(function (plugin) { var _a; return (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin); });
        this.plugins = [];
        this.client = client;
    };
    Timeline.prototype.push = function (event) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.queue.push([event, resolve]);
            _this.scheduleApply(0);
        });
    };
    Timeline.prototype.scheduleApply = function (timeout) {
        var _this = this;
        if (this.applying)
            return;
        this.applying = true;
        setTimeout(function () {
            void _this.apply(_this.queue.shift()).then(function () {
                _this.applying = false;
                if (_this.queue.length > 0) {
                    _this.scheduleApply(0);
                }
            });
        }, timeout);
    };
    Timeline.prototype.apply = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, event, _b, resolve, before, before_1, before_1_1, plugin, e, e_1_1, enrichment, enrichment_1, enrichment_1_1, plugin, e, e_2_1, destination, executeDestinations;
            var e_1, _c, e_2, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!item) {
                            return [2 /*return*/];
                        }
                        _a = __read(item, 1), event = _a[0];
                        _b = __read(item, 2), resolve = _b[1];
                        before = this.plugins.filter(function (plugin) { return plugin.type === 'before'; });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 6, 7, 8]);
                        before_1 = __values(before), before_1_1 = before_1.next();
                        _e.label = 2;
                    case 2:
                        if (!!before_1_1.done) return [3 /*break*/, 5];
                        plugin = before_1_1.value;
                        /* istanbul ignore if */
                        if (!plugin.execute) {
                            // do nothing
                            return [3 /*break*/, 4];
                        }
                        return [4 /*yield*/, plugin.execute(__assign$1({}, event))];
                    case 3:
                        e = _e.sent();
                        if (e === null) {
                            resolve({ event: event, code: 0, message: '' });
                            return [2 /*return*/];
                        }
                        else {
                            event = e;
                        }
                        _e.label = 4;
                    case 4:
                        before_1_1 = before_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _e.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (before_1_1 && !before_1_1.done && (_c = before_1.return)) _c.call(before_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        enrichment = this.plugins.filter(function (plugin) { return plugin.type === 'enrichment' || plugin.type === undefined; });
                        _e.label = 9;
                    case 9:
                        _e.trys.push([9, 14, 15, 16]);
                        enrichment_1 = __values(enrichment), enrichment_1_1 = enrichment_1.next();
                        _e.label = 10;
                    case 10:
                        if (!!enrichment_1_1.done) return [3 /*break*/, 13];
                        plugin = enrichment_1_1.value;
                        /* istanbul ignore if */
                        if (!plugin.execute) {
                            // do nothing
                            return [3 /*break*/, 12];
                        }
                        return [4 /*yield*/, plugin.execute(__assign$1({}, event))];
                    case 11:
                        e = _e.sent();
                        if (e === null) {
                            resolve({ event: event, code: 0, message: '' });
                            return [2 /*return*/];
                        }
                        else {
                            event = e;
                        }
                        _e.label = 12;
                    case 12:
                        enrichment_1_1 = enrichment_1.next();
                        return [3 /*break*/, 10];
                    case 13: return [3 /*break*/, 16];
                    case 14:
                        e_2_1 = _e.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 16];
                    case 15:
                        try {
                            if (enrichment_1_1 && !enrichment_1_1.done && (_d = enrichment_1.return)) _d.call(enrichment_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 16:
                        destination = this.plugins.filter(function (plugin) { return plugin.type === 'destination'; });
                        executeDestinations = destination.map(function (plugin) {
                            var eventClone = __assign$1({}, event);
                            return plugin.execute(eventClone).catch(function (e) { return buildResult(eventClone, 0, String(e)); });
                        });
                        void Promise.all(executeDestinations).then(function (_a) {
                            var _b = __read(_a, 1), result = _b[0];
                            var resolveResult = result || buildResult(event, 100, 'Event not tracked, no destination plugins on the instance');
                            resolve(resolveResult);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Timeline.prototype.flush = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queue, destination, executeDestinations;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queue = this.queue;
                        this.queue = [];
                        return [4 /*yield*/, Promise.all(queue.map(function (item) { return _this.apply(item); }))];
                    case 1:
                        _a.sent();
                        destination = this.plugins.filter(function (plugin) { return plugin.type === 'destination'; });
                        executeDestinations = destination.map(function (plugin) {
                            return plugin.flush && plugin.flush();
                        });
                        return [4 /*yield*/, Promise.all(executeDestinations)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Timeline;
}());

var UNSET_VALUE = '-';
var AMPLITUDE_PREFIX = 'AMP';
var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
var EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
var AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
var EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch';

var MAX_PROPERTY_KEYS = 1000;
var isValidObject = function (properties) {
    if (Object.keys(properties).length > MAX_PROPERTY_KEYS) {
        return false;
    }
    for (var key in properties) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var value = properties[key];
        if (!isValidProperties(key, value))
            return false;
    }
    return true;
};
var isValidProperties = function (property, value) {
    var e_1, _a;
    if (typeof property !== 'string')
        return false;
    if (Array.isArray(value)) {
        var isValid = true;
        try {
            for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
                var valueElement = value_1_1.value;
                if (Array.isArray(valueElement)) {
                    return false;
                }
                else if (typeof valueElement === 'object') {
                    isValid = isValid && isValidObject(valueElement);
                }
                else if (!['number', 'string'].includes(typeof valueElement)) {
                    return false;
                }
                if (!isValid) {
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else if (value === null || value === undefined) {
        return false;
    }
    else if (typeof value === 'object') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return isValidObject(value);
    }
    else if (!['number', 'string', 'boolean'].includes(typeof value)) {
        return false;
    }
    return true;
};

var Identify = /** @class */ (function () {
    function Identify() {
        this._propertySet = new Set();
        this._properties = {};
    }
    Identify.prototype.getUserProperties = function () {
        return __assign$1({}, this._properties);
    };
    Identify.prototype.set = function (property, value) {
        this._safeSet(IdentifyOperation.SET, property, value);
        return this;
    };
    Identify.prototype.setOnce = function (property, value) {
        this._safeSet(IdentifyOperation.SET_ONCE, property, value);
        return this;
    };
    Identify.prototype.append = function (property, value) {
        this._safeSet(IdentifyOperation.APPEND, property, value);
        return this;
    };
    Identify.prototype.prepend = function (property, value) {
        this._safeSet(IdentifyOperation.PREPEND, property, value);
        return this;
    };
    Identify.prototype.postInsert = function (property, value) {
        this._safeSet(IdentifyOperation.POSTINSERT, property, value);
        return this;
    };
    Identify.prototype.preInsert = function (property, value) {
        this._safeSet(IdentifyOperation.PREINSERT, property, value);
        return this;
    };
    Identify.prototype.remove = function (property, value) {
        this._safeSet(IdentifyOperation.REMOVE, property, value);
        return this;
    };
    Identify.prototype.add = function (property, value) {
        this._safeSet(IdentifyOperation.ADD, property, value);
        return this;
    };
    Identify.prototype.unset = function (property) {
        this._safeSet(IdentifyOperation.UNSET, property, UNSET_VALUE);
        return this;
    };
    Identify.prototype.clearAll = function () {
        // When clear all happens, all properties are unset. Reset the entire object.
        this._properties = {};
        this._properties[IdentifyOperation.CLEAR_ALL] = UNSET_VALUE;
        return this;
    };
    // Returns whether or not this set actually worked.
    Identify.prototype._safeSet = function (operation, property, value) {
        if (this._validate(operation, property, value)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var userPropertyMap = this._properties[operation];
            if (userPropertyMap === undefined) {
                userPropertyMap = {};
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                this._properties[operation] = userPropertyMap;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            userPropertyMap[property] = value;
            this._propertySet.add(property);
            return true;
        }
        return false;
    };
    Identify.prototype._validate = function (operation, property, value) {
        if (this._properties[IdentifyOperation.CLEAR_ALL] !== undefined) {
            // clear all already set. Skipping operation;
            return false;
        }
        if (this._propertySet.has(property)) {
            // Property already used. Skipping operation
            return false;
        }
        if (operation === IdentifyOperation.ADD) {
            return typeof value === 'number';
        }
        if (operation !== IdentifyOperation.UNSET && operation !== IdentifyOperation.REMOVE) {
            return isValidProperties(property, value);
        }
        return true;
    };
    return Identify;
}());

var createTrackEvent = function (eventInput, eventProperties, eventOptions) {
    var baseEvent = typeof eventInput === 'string' ? { event_type: eventInput } : eventInput;
    return __assign$1(__assign$1(__assign$1({}, baseEvent), eventOptions), (eventProperties && { event_properties: eventProperties }));
};
var createIdentifyEvent = function (identify, eventOptions) {
    var identifyEvent = __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify.getUserProperties() });
    return identifyEvent;
};
var createGroupIdentifyEvent = function (groupType, groupName, identify, eventOptions) {
    var _a;
    var groupIdentify = __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.GROUP_IDENTIFY, group_properties: identify.getUserProperties(), groups: (_a = {},
            _a[groupType] = groupName,
            _a) });
    return groupIdentify;
};
var createGroupEvent = function (groupType, groupName, eventOptions) {
    var _a;
    var identify = new Identify();
    identify.set(groupType, groupName);
    var groupEvent = __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.IDENTIFY, user_properties: identify.getUserProperties(), groups: (_a = {},
            _a[groupType] = groupName,
            _a) });
    return groupEvent;
};
var createRevenueEvent = function (revenue, eventOptions) {
    return __assign$1(__assign$1({}, eventOptions), { event_type: SpecialEventType.REVENUE, event_properties: revenue.getEventProperties() });
};

var returnWrapper = function (awaitable) { return ({
    promise: awaitable || Promise.resolve(),
}); };

var AmplitudeCore = /** @class */ (function () {
    function AmplitudeCore(name) {
        if (name === void 0) { name = '$default'; }
        this.initializing = false;
        this.q = [];
        this.dispatchQ = [];
        this.logEvent = this.track.bind(this);
        this.timeline = new Timeline(this);
        this.name = name;
    }
    AmplitudeCore.prototype._init = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.config = config;
                        this.timeline.reset(this);
                        return [4 /*yield*/, this.runQueuedFunctions('q')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AmplitudeCore.prototype.runQueuedFunctions = function (queueName) {
        return __awaiter(this, void 0, void 0, function () {
            var queuedFunctions, queuedFunctions_1, queuedFunctions_1_1, queuedFunction, e_1_1;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queuedFunctions = this[queueName];
                        this[queueName] = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        queuedFunctions_1 = __values(queuedFunctions), queuedFunctions_1_1 = queuedFunctions_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!queuedFunctions_1_1.done) return [3 /*break*/, 5];
                        queuedFunction = queuedFunctions_1_1.value;
                        return [4 /*yield*/, queuedFunction()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        queuedFunctions_1_1 = queuedFunctions_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _b.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (queuedFunctions_1_1 && !queuedFunctions_1_1.done && (_a = queuedFunctions_1.return)) _a.call(queuedFunctions_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AmplitudeCore.prototype.track = function (eventInput, eventProperties, eventOptions) {
        var event = createTrackEvent(eventInput, eventProperties, eventOptions);
        return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore.prototype.identify = function (identify, eventOptions) {
        var event = createIdentifyEvent(identify, eventOptions);
        return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore.prototype.groupIdentify = function (groupType, groupName, identify, eventOptions) {
        var event = createGroupIdentifyEvent(groupType, groupName, identify, eventOptions);
        return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore.prototype.setGroup = function (groupType, groupName, eventOptions) {
        var event = createGroupEvent(groupType, groupName, eventOptions);
        return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore.prototype.revenue = function (revenue, eventOptions) {
        var event = createRevenueEvent(revenue, eventOptions);
        return returnWrapper(this.dispatch(event));
    };
    AmplitudeCore.prototype.add = function (plugin) {
        if (!this.config) {
            this.q.push(this.add.bind(this, plugin));
            return returnWrapper();
        }
        return returnWrapper(this.timeline.register(plugin, this.config));
    };
    AmplitudeCore.prototype.remove = function (pluginName) {
        if (!this.config) {
            this.q.push(this.remove.bind(this, pluginName));
            return returnWrapper();
        }
        return returnWrapper(this.timeline.deregister(pluginName));
    };
    AmplitudeCore.prototype.dispatchWithCallback = function (event, callback) {
        if (!this.config) {
            return callback(buildResult(event, 0, CLIENT_NOT_INITIALIZED));
        }
        void this.process(event).then(callback);
    };
    AmplitudeCore.prototype.dispatch = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.config) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            _this.dispatchQ.push(_this.dispatchWithCallback.bind(_this, event, resolve));
                        })];
                }
                return [2 /*return*/, this.process(event)];
            });
        });
    };
    AmplitudeCore.prototype.process = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_2, message, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // skip event processing if opt out
                        if (this.config.optOut) {
                            return [2 /*return*/, buildResult(event, 0, OPT_OUT_MESSAGE)];
                        }
                        return [4 /*yield*/, this.timeline.push(event)];
                    case 1:
                        result = _a.sent();
                        result.code === 200
                            ? this.config.loggerProvider.log(result.message)
                            : result.code === 100
                                ? this.config.loggerProvider.warn(result.message)
                                : this.config.loggerProvider.error(result.message);
                        return [2 /*return*/, result];
                    case 2:
                        e_2 = _a.sent();
                        message = String(e_2);
                        this.config.loggerProvider.error(message);
                        result = buildResult(event, 0, message);
                        return [2 /*return*/, result];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AmplitudeCore.prototype.setOptOut = function (optOut) {
        if (!this.config) {
            this.q.push(this.setOptOut.bind(this, Boolean(optOut)));
            return;
        }
        this.config.optOut = Boolean(optOut);
    };
    AmplitudeCore.prototype.flush = function () {
        return returnWrapper(this.timeline.flush());
    };
    return AmplitudeCore;
}());

var Revenue = /** @class */ (function () {
    function Revenue() {
        this.productId = '';
        this.quantity = 1;
        this.price = 0.0;
    }
    Revenue.prototype.setProductId = function (productId) {
        this.productId = productId;
        return this;
    };
    Revenue.prototype.setQuantity = function (quantity) {
        if (quantity > 0) {
            this.quantity = quantity;
        }
        return this;
    };
    Revenue.prototype.setPrice = function (price) {
        this.price = price;
        return this;
    };
    Revenue.prototype.setRevenueType = function (revenueType) {
        this.revenueType = revenueType;
        return this;
    };
    Revenue.prototype.setRevenue = function (revenue) {
        this.revenue = revenue;
        return this;
    };
    Revenue.prototype.setEventProperties = function (properties) {
        if (isValidObject(properties)) {
            this.properties = properties;
        }
        return this;
    };
    Revenue.prototype.getEventProperties = function () {
        var eventProperties = this.properties ? __assign$1({}, this.properties) : {};
        eventProperties[RevenueProperty.REVENUE_PRODUCT_ID] = this.productId;
        eventProperties[RevenueProperty.REVENUE_QUANTITY] = this.quantity;
        eventProperties[RevenueProperty.REVENUE_PRICE] = this.price;
        eventProperties[RevenueProperty.REVENUE_TYPE] = this.revenueType;
        eventProperties[RevenueProperty.REVENUE] = this.revenue;
        return eventProperties;
    };
    return Revenue;
}());

// Creates an array of elements split into groups the length of size.
// If array can't be split evenly, the final chunk will be the remaining elements.
// Works similary as https://lodash.com/docs/4.17.15#chunk
var chunk = function (arr, size) {
    var chunkSize = Math.max(size, 1);
    return arr.reduce(function (chunks, element, index) {
        var chunkIndex = Math.floor(index / chunkSize);
        if (!chunks[chunkIndex]) {
            chunks[chunkIndex] = [];
        }
        chunks[chunkIndex].push(element);
        return chunks;
    }, []);
};

var PREFIX = 'Amplitude Logger ';
var Logger = /** @class */ (function () {
    function Logger() {
        this.logLevel = LogLevel.None;
    }
    Logger.prototype.disable = function () {
        this.logLevel = LogLevel.None;
    };
    Logger.prototype.enable = function (logLevel) {
        if (logLevel === void 0) { logLevel = LogLevel.Warn; }
        this.logLevel = logLevel;
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Verbose) {
            return;
        }
        console.log("".concat(PREFIX, "[Log]: ").concat(args.join(' ')));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Warn) {
            return;
        }
        console.warn("".concat(PREFIX, "[Warn]: ").concat(args.join(' ')));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Error) {
            return;
        }
        console.error("".concat(PREFIX, "[Error]: ").concat(args.join(' ')));
    };
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.logLevel < LogLevel.Debug) {
            return;
        }
        // console.debug output is hidden by default in chrome
        console.log("".concat(PREFIX, "[Debug]: ").concat(args.join(' ')));
    };
    return Logger;
}());

var getDefaultConfig = function () { return ({
    flushMaxRetries: 12,
    flushQueueSize: 200,
    flushIntervalMillis: 10000,
    instanceName: '$default_instance',
    logLevel: LogLevel.Warn,
    loggerProvider: new Logger(),
    offline: false,
    optOut: false,
    serverUrl: AMPLITUDE_SERVER_URL,
    serverZone: 'US',
    useBatch: false,
}); };
var Config = /** @class */ (function () {
    function Config(options) {
        var _a, _b, _c, _d;
        this._optOut = false;
        var defaultConfig = getDefaultConfig();
        this.apiKey = options.apiKey;
        this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.instanceName = options.instanceName || defaultConfig.instanceName;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
        this.minIdLength = options.minIdLength;
        this.plan = options.plan;
        this.ingestionMetadata = options.ingestionMetadata;
        this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
        this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
        this.serverZone = serverConfig.serverZone;
        this.serverUrl = serverConfig.serverUrl;
    }
    Object.defineProperty(Config.prototype, "optOut", {
        get: function () {
            return this._optOut;
        },
        set: function (optOut) {
            this._optOut = optOut;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}());
var getServerUrl = function (serverZone, useBatch) {
    if (serverZone === 'EU') {
        return useBatch ? EU_AMPLITUDE_BATCH_SERVER_URL : EU_AMPLITUDE_SERVER_URL;
    }
    return useBatch ? AMPLITUDE_BATCH_SERVER_URL : AMPLITUDE_SERVER_URL;
};
var createServerConfig = function (serverUrl, serverZone, useBatch) {
    if (serverUrl === void 0) { serverUrl = ''; }
    if (serverZone === void 0) { serverZone = getDefaultConfig().serverZone; }
    if (useBatch === void 0) { useBatch = getDefaultConfig().useBatch; }
    if (serverUrl) {
        return { serverUrl: serverUrl, serverZone: undefined };
    }
    var _serverZone = ['US', 'EU'].includes(serverZone) ? serverZone : getDefaultConfig().serverZone;
    return {
        serverZone: _serverZone,
        serverUrl: getServerUrl(_serverZone, useBatch),
    };
};

function getErrorMessage(error) {
    if (error instanceof Error)
        return error.message;
    return String(error);
}
function getResponseBodyString(res) {
    var responseBodyString = '';
    try {
        if ('body' in res) {
            responseBodyString = JSON.stringify(res.body, null, 2);
        }
    }
    catch (_a) {
        // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
    }
    return responseBodyString;
}
var Destination = /** @class */ (function () {
    function Destination() {
        this.name = 'amplitude';
        this.type = 'destination';
        this.retryTimeout = 1000;
        this.throttleTimeout = 30000;
        this.storageKey = '';
        this.scheduled = null;
        this.queue = [];
    }
    Destination.prototype.setup = function (config) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var unsent;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.config = config;
                        this.storageKey = "".concat(STORAGE_PREFIX, "_").concat(this.config.apiKey.substring(0, 10));
                        return [4 /*yield*/, ((_a = this.config.storageProvider) === null || _a === void 0 ? void 0 : _a.get(this.storageKey))];
                    case 1:
                        unsent = _b.sent();
                        this.saveEvents(); // sets storage to '[]'
                        if (unsent && unsent.length > 0) {
                            void Promise.all(unsent.map(function (event) { return _this.execute(event); })).catch();
                        }
                        return [2 /*return*/, Promise.resolve(undefined)];
                }
            });
        });
    };
    Destination.prototype.execute = function (event) {
        var _this = this;
        return new Promise(function (resolve) {
            var context = {
                event: event,
                attempts: 0,
                callback: function (result) { return resolve(result); },
                timeout: 0,
            };
            void _this.addToQueue(context);
        });
    };
    Destination.prototype.addToQueue = function () {
        var _this = this;
        var list = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            list[_i] = arguments[_i];
        }
        var tryable = list.filter(function (context) {
            if (context.attempts < _this.config.flushMaxRetries) {
                context.attempts += 1;
                return true;
            }
            void _this.fulfillRequest([context], 500, MAX_RETRIES_EXCEEDED_MESSAGE);
            return false;
        });
        tryable.forEach(function (context) {
            _this.queue = _this.queue.concat(context);
            if (context.timeout === 0) {
                _this.schedule(_this.config.flushIntervalMillis);
                return;
            }
            setTimeout(function () {
                context.timeout = 0;
                _this.schedule(0);
            }, context.timeout);
        });
        this.saveEvents();
    };
    Destination.prototype.schedule = function (timeout) {
        var _this = this;
        if (this.scheduled || this.config.offline) {
            return;
        }
        this.scheduled = setTimeout(function () {
            void _this.flush(true).then(function () {
                if (_this.queue.length > 0) {
                    _this.schedule(timeout);
                }
            });
        }, timeout);
    };
    Destination.prototype.flush = function (useRetry) {
        if (useRetry === void 0) { useRetry = false; }
        return __awaiter(this, void 0, void 0, function () {
            var list, later, batches;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Skip flush if offline
                        if (this.config.offline) {
                            this.config.loggerProvider.debug('Skipping flush while offline.');
                            return [2 /*return*/];
                        }
                        list = [];
                        later = [];
                        this.queue.forEach(function (context) { return (context.timeout === 0 ? list.push(context) : later.push(context)); });
                        this.queue = later;
                        if (this.scheduled) {
                            clearTimeout(this.scheduled);
                            this.scheduled = null;
                        }
                        batches = chunk(list, this.config.flushQueueSize);
                        return [4 /*yield*/, Promise.all(batches.map(function (batch) { return _this.send(batch, useRetry); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Destination.prototype.send = function (list, useRetry) {
        if (useRetry === void 0) { useRetry = true; }
        return __awaiter(this, void 0, void 0, function () {
            var payload, serverUrl, res, e_1, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.apiKey) {
                            return [2 /*return*/, this.fulfillRequest(list, 400, MISSING_API_KEY_MESSAGE)];
                        }
                        payload = {
                            api_key: this.config.apiKey,
                            events: list.map(function (context) {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                var _a = context.event; _a.extra; var eventWithoutExtra = __rest(_a, ["extra"]);
                                return eventWithoutExtra;
                            }),
                            options: {
                                min_id_length: this.config.minIdLength,
                            },
                            client_upload_time: new Date().toISOString(),
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        serverUrl = createServerConfig(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl;
                        return [4 /*yield*/, this.config.transportProvider.send(serverUrl, payload)];
                    case 2:
                        res = _a.sent();
                        if (res === null) {
                            this.fulfillRequest(list, 0, UNEXPECTED_ERROR_MESSAGE);
                            return [2 /*return*/];
                        }
                        if (!useRetry) {
                            if ('body' in res) {
                                this.fulfillRequest(list, res.statusCode, "".concat(res.status, ": ").concat(getResponseBodyString(res)));
                            }
                            else {
                                this.fulfillRequest(list, res.statusCode, res.status);
                            }
                            return [2 /*return*/];
                        }
                        this.handleResponse(res, list);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        errorMessage = getErrorMessage(e_1);
                        this.config.loggerProvider.error(errorMessage);
                        this.fulfillRequest(list, 0, errorMessage);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Destination.prototype.handleResponse = function (res, list) {
        var status = res.status;
        switch (status) {
            case Status.Success: {
                this.handleSuccessResponse(res, list);
                break;
            }
            case Status.Invalid: {
                this.handleInvalidResponse(res, list);
                break;
            }
            case Status.PayloadTooLarge: {
                this.handlePayloadTooLargeResponse(res, list);
                break;
            }
            case Status.RateLimit: {
                this.handleRateLimitResponse(res, list);
                break;
            }
            default: {
                // log intermediate event status before retry
                this.config.loggerProvider.warn("{code: 0, error: \"Status '".concat(status, "' provided for ").concat(list.length, " events\"}"));
                this.handleOtherResponse(list);
                break;
            }
        }
    };
    Destination.prototype.handleSuccessResponse = function (res, list) {
        this.fulfillRequest(list, res.statusCode, SUCCESS_MESSAGE);
    };
    Destination.prototype.handleInvalidResponse = function (res, list) {
        var _this = this;
        if (res.body.missingField || res.body.error.startsWith(INVALID_API_KEY)) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        var dropIndex = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(Object.values(res.body.eventsWithInvalidFields)), false), __read(Object.values(res.body.eventsWithMissingFields)), false), __read(Object.values(res.body.eventsWithInvalidIdLengths)), false), __read(res.body.silencedEvents), false).flat();
        var dropIndexSet = new Set(dropIndex);
        var retry = list.filter(function (context, index) {
            if (dropIndexSet.has(index)) {
                _this.fulfillRequest([context], res.statusCode, res.body.error);
                return;
            }
            return true;
        });
        if (retry.length > 0) {
            // log intermediate event status before retry
            this.config.loggerProvider.warn(getResponseBodyString(res));
        }
        this.addToQueue.apply(this, __spreadArray([], __read(retry), false));
    };
    Destination.prototype.handlePayloadTooLargeResponse = function (res, list) {
        if (list.length === 1) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        // log intermediate event status before retry
        this.config.loggerProvider.warn(getResponseBodyString(res));
        this.config.flushQueueSize /= 2;
        this.addToQueue.apply(this, __spreadArray([], __read(list), false));
    };
    Destination.prototype.handleRateLimitResponse = function (res, list) {
        var _this = this;
        var dropUserIds = Object.keys(res.body.exceededDailyQuotaUsers);
        var dropDeviceIds = Object.keys(res.body.exceededDailyQuotaDevices);
        var throttledIndex = res.body.throttledEvents;
        var dropUserIdsSet = new Set(dropUserIds);
        var dropDeviceIdsSet = new Set(dropDeviceIds);
        var throttledIndexSet = new Set(throttledIndex);
        var retry = list.filter(function (context, index) {
            if ((context.event.user_id && dropUserIdsSet.has(context.event.user_id)) ||
                (context.event.device_id && dropDeviceIdsSet.has(context.event.device_id))) {
                _this.fulfillRequest([context], res.statusCode, res.body.error);
                return;
            }
            if (throttledIndexSet.has(index)) {
                context.timeout = _this.throttleTimeout;
            }
            return true;
        });
        if (retry.length > 0) {
            // log intermediate event status before retry
            this.config.loggerProvider.warn(getResponseBodyString(res));
        }
        this.addToQueue.apply(this, __spreadArray([], __read(retry), false));
    };
    Destination.prototype.handleOtherResponse = function (list) {
        var _this = this;
        this.addToQueue.apply(this, __spreadArray([], __read(list.map(function (context) {
            context.timeout = context.attempts * _this.retryTimeout;
            return context;
        })), false));
    };
    Destination.prototype.fulfillRequest = function (list, code, message) {
        this.saveEvents();
        list.forEach(function (context) { return context.callback(buildResult(context.event, code, message)); });
    };
    /**
     * Saves events to storage
     * This is called on
     * 1) new events are added to queue; or
     * 2) response comes back for a request
     */
    Destination.prototype.saveEvents = function () {
        if (!this.config.storageProvider) {
            return;
        }
        var events = Array.from(this.queue.map(function (context) { return context.event; }));
        void this.config.storageProvider.set(this.storageKey, events);
    };
    return Destination;
}());

var getStacktrace = function (ignoreDepth) {
    if (ignoreDepth === void 0) { ignoreDepth = 0; }
    var trace = new Error().stack || '';
    return trace
        .split('\n')
        .slice(2 + ignoreDepth)
        .map(function (text) { return text.trim(); });
};
// This hook makes sure we always get the latest logger and logLevel.
var getClientLogConfig = function (client) { return function () {
    var _a = __assign$1({}, client.config), logger = _a.loggerProvider, logLevel = _a.logLevel;
    return {
        logger: logger,
        logLevel: logLevel,
    };
}; };
// This is a convenient function to get the attribute from object with string path, similar to lodash '#get'.
var getValueByStringPath = function (obj, path) {
    var e_1, _a;
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    try {
        for (var _b = __values(path.split('.')), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            if (attr in obj) {
                obj = obj[attr];
            }
            else {
                return;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return obj;
};
var getClientStates = function (client, paths) { return function () {
    var e_2, _a;
    var res = {};
    try {
        for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
            var path = paths_1_1.value;
            res[path] = getValueByStringPath(client, path);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return res;
}; };
var debugWrapper = function (fn, fnName, getLogConfig, getStates, fnContext) {
    if (fnContext === void 0) { fnContext = null; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = getLogConfig(), logger = _a.logger, logLevel = _a.logLevel;
        // return early if possible to reduce overhead
        if ((logLevel && logLevel < LogLevel.Debug) || !logLevel || !logger) {
            return fn.apply(fnContext, args);
        }
        var debugContext = {
            type: 'invoke public method',
            name: fnName,
            args: args,
            stacktrace: getStacktrace(1),
            time: {
                start: new Date().toISOString(),
            },
            states: {},
        };
        if (getStates && debugContext.states) {
            debugContext.states.before = getStates();
        }
        var result = fn.apply(fnContext, args);
        if (result && result.promise) {
            // if result is a promise, add the callback
            result.promise.then(function () {
                if (getStates && debugContext.states) {
                    debugContext.states.after = getStates();
                }
                if (debugContext.time) {
                    debugContext.time.end = new Date().toISOString();
                }
                logger.debug(JSON.stringify(debugContext, null, 2));
            });
        }
        else {
            if (getStates && debugContext.states) {
                debugContext.states.after = getStates();
            }
            if (debugContext.time) {
                debugContext.time.end = new Date().toISOString();
            }
            logger.debug(JSON.stringify(debugContext, null, 2));
        }
        return result;
    };
};

var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.memoryStorage = new Map();
    }
    MemoryStorage.prototype.isEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    MemoryStorage.prototype.get = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.memoryStorage.get(key)];
            });
        });
    };
    MemoryStorage.prototype.getRaw = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(key)];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, value ? JSON.stringify(value) : undefined];
                }
            });
        });
    };
    MemoryStorage.prototype.set = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.memoryStorage.set(key, value);
                return [2 /*return*/];
            });
        });
    };
    MemoryStorage.prototype.remove = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.memoryStorage.delete(key);
                return [2 /*return*/];
            });
        });
    };
    MemoryStorage.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.memoryStorage.clear();
                return [2 /*return*/];
            });
        });
    };
    return MemoryStorage;
}());

/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
var BaseTransport = /** @class */ (function () {
    function BaseTransport() {
    }
    BaseTransport.prototype.send = function (_serverUrl, _payload) {
        return Promise.resolve(null);
    };
    BaseTransport.prototype.buildResponse = function (responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== 'object') {
            return null;
        }
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch (status) {
            case Status.Success:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                        payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                        serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0,
                    },
                };
            case Status.Invalid:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
                        missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
                        eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                        eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                        eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                        epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                        exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                        silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                        silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                        throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                        throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : [],
                    },
                };
            case Status.PayloadTooLarge:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : '',
                    },
                };
            case Status.RateLimit:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
                        epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                        throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                        throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                        exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                        exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                        throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : [],
                    },
                };
            case Status.Timeout:
            default:
                return {
                    status: status,
                    statusCode: statusCode,
                };
        }
    };
    BaseTransport.prototype.buildStatus = function (code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code === 413) {
            return Status.PayloadTooLarge;
        }
        if (code === 408) {
            return Status.Timeout;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    };
    return BaseTransport;
}());

/* eslint-disable no-restricted-globals */
/* Only file allowed to access to globalThis, window, self */
var getGlobalScope = function () {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    return undefined;
};

var getQueryParams = function () {
    var _a;
    var globalScope = getGlobalScope();
    /* istanbul ignore if */
    if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) {
        return {};
    }
    var pairs = globalScope.location.search.substring(1).split('&').filter(Boolean);
    var params = pairs.reduce(function (acc, curr) {
        var query = curr.split('=', 2);
        var key = tryDecodeURIComponent(query[0]);
        var value = tryDecodeURIComponent(query[1]);
        if (!value) {
            return acc;
        }
        acc[key] = value;
        return acc;
    }, {});
    return params;
};
var tryDecodeURIComponent = function (value) {
    if (value === void 0) { value = ''; }
    try {
        return decodeURIComponent(value);
    }
    catch (_a) {
        return '';
    }
};

var UTM_CAMPAIGN = 'utm_campaign';
var UTM_CONTENT = 'utm_content';
var UTM_ID = 'utm_id';
var UTM_MEDIUM = 'utm_medium';
var UTM_SOURCE = 'utm_source';
var UTM_TERM = 'utm_term';
var DCLID = 'dclid';
var FBCLID = 'fbclid';
var GBRAID = 'gbraid';
var GCLID = 'gclid';
var KO_CLICK_ID = 'ko_click_id';
var LI_FAT_ID = 'li_fat_id';
var MSCLKID = 'msclkid';
var RDT_CID = 'rtd_cid';
var TTCLID = 'ttclid';
var TWCLID = 'twclid';
var WBRAID = 'wbraid';
var BASE_CAMPAIGN = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    referrer: undefined,
    referring_domain: undefined,
    dclid: undefined,
    gbraid: undefined,
    gclid: undefined,
    fbclid: undefined,
    ko_click_id: undefined,
    li_fat_id: undefined,
    msclkid: undefined,
    rtd_cid: undefined,
    ttclid: undefined,
    twclid: undefined,
    wbraid: undefined,
};

var CampaignParser = /** @class */ (function () {
    function CampaignParser() {
    }
    CampaignParser.prototype.parse = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, __assign$1(__assign$1(__assign$1(__assign$1({}, BASE_CAMPAIGN), this.getUtmParam()), this.getReferrer()), this.getClickIds())];
            });
        });
    };
    CampaignParser.prototype.getUtmParam = function () {
        var params = getQueryParams();
        var utmCampaign = params[UTM_CAMPAIGN];
        var utmContent = params[UTM_CONTENT];
        var utmId = params[UTM_ID];
        var utmMedium = params[UTM_MEDIUM];
        var utmSource = params[UTM_SOURCE];
        var utmTerm = params[UTM_TERM];
        return {
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            utm_id: utmId,
            utm_medium: utmMedium,
            utm_source: utmSource,
            utm_term: utmTerm,
        };
    };
    CampaignParser.prototype.getReferrer = function () {
        var _a, _b;
        var data = {
            referrer: undefined,
            referring_domain: undefined,
        };
        try {
            data.referrer = document.referrer || undefined;
            data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split('/')[2]) !== null && _b !== void 0 ? _b : undefined;
        }
        catch (_c) {
            // nothing to track
        }
        return data;
    };
    CampaignParser.prototype.getClickIds = function () {
        var _a;
        var params = getQueryParams();
        return _a = {},
            _a[DCLID] = params[DCLID],
            _a[FBCLID] = params[FBCLID],
            _a[GBRAID] = params[GBRAID],
            _a[GCLID] = params[GCLID],
            _a[KO_CLICK_ID] = params[KO_CLICK_ID],
            _a[LI_FAT_ID] = params[LI_FAT_ID],
            _a[MSCLKID] = params[MSCLKID],
            _a[RDT_CID] = params[RDT_CID],
            _a[TTCLID] = params[TTCLID],
            _a[TWCLID] = params[TWCLID],
            _a[WBRAID] = params[WBRAID],
            _a;
    };
    return CampaignParser;
}());

var getCookieName = function (apiKey, postKey, limit) {
    if (postKey === void 0) { postKey = ''; }
    if (limit === void 0) { limit = 10; }
    return [AMPLITUDE_PREFIX, postKey, apiKey.substring(0, limit)].filter(Boolean).join('_');
};
var getOldCookieName = function (apiKey) {
    return "".concat(AMPLITUDE_PREFIX.toLowerCase(), "_").concat(apiKey.substring(0, 6));
};

var isNewSession = function (sessionTimeout, lastEventTime) {
    if (lastEventTime === void 0) { lastEventTime = Date.now(); }
    var currentTime = Date.now();
    var timeSinceLastEvent = currentTime - lastEventTime;
    return timeSinceLastEvent > sessionTimeout;
};

var CookieStorage = /** @class */ (function () {
    function CookieStorage(options) {
        this.options = __assign$1({}, options);
    }
    CookieStorage.prototype.isEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var testStrorage, testKey, value;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        /* istanbul ignore if */
                        if (!getGlobalScope()) {
                            return [2 /*return*/, false];
                        }
                        CookieStorage.testValue = String(Date.now());
                        testStrorage = new CookieStorage(this.options);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 7]);
                        return [4 /*yield*/, testStrorage.set(testKey, CookieStorage.testValue)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, testStrorage.get(testKey)];
                    case 3:
                        value = _b.sent();
                        return [2 /*return*/, value === CookieStorage.testValue];
                    case 4:
                        _b.sent();
                        /* istanbul ignore next */
                        return [2 /*return*/, false];
                    case 5: return [4 /*yield*/, testStrorage.remove(testKey)];
                    case 6:
                        _b.sent();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    CookieStorage.prototype.get = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRaw(key)];
                    case 1:
                        value = _a.sent();
                        if (!value) {
                            return [2 /*return*/, undefined];
                        }
                        try {
                            try {
                                value = decodeURIComponent(atob(value));
                            }
                            catch (_b) {
                                // value not encoded
                            }
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                            return [2 /*return*/, JSON.parse(value)];
                        }
                        catch (_c) {
                            /* istanbul ignore next */
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieStorage.prototype.getRaw = function (key) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var globalScope, cookie, match;
            return __generator(this, function (_c) {
                globalScope = getGlobalScope();
                cookie = (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) === null || _a === void 0 ? void 0 : _a.cookie.split('; ')) !== null && _b !== void 0 ? _b : [];
                match = cookie.find(function (c) { return c.indexOf(key + '=') === 0; });
                if (!match) {
                    return [2 /*return*/, undefined];
                }
                return [2 /*return*/, match.substring(key.length + 1)];
            });
        });
    };
    CookieStorage.prototype.set = function (key, value) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var expirationDays, expires, expireDate, date, str, globalScope;
            return __generator(this, function (_b) {
                try {
                    expirationDays = (_a = this.options.expirationDays) !== null && _a !== void 0 ? _a : 0;
                    expires = value !== null ? expirationDays : -1;
                    expireDate = undefined;
                    if (expires) {
                        date = new Date();
                        date.setTime(date.getTime() + expires * 24 * 60 * 60 * 1000);
                        expireDate = date;
                    }
                    str = "".concat(key, "=").concat(btoa(encodeURIComponent(JSON.stringify(value))));
                    if (expireDate) {
                        str += "; expires=".concat(expireDate.toUTCString());
                    }
                    str += '; path=/';
                    if (this.options.domain) {
                        str += "; domain=".concat(this.options.domain);
                    }
                    if (this.options.secure) {
                        str += '; Secure';
                    }
                    if (this.options.sameSite) {
                        str += "; SameSite=".concat(this.options.sameSite);
                    }
                    globalScope = getGlobalScope();
                    if (globalScope) {
                        globalScope.document.cookie = str;
                    }
                }
                catch (_c) {
                    //
                }
                return [2 /*return*/];
            });
        });
    };
    CookieStorage.prototype.remove = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.set(key, null)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CookieStorage.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return CookieStorage;
}());

var FetchTransport = /** @class */ (function (_super) {
    __extends(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchTransport.prototype.send = function (serverUrl, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var options, response, responsePayload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        /* istanbul ignore if */
                        if (typeof fetch === 'undefined') {
                            throw new Error('FetchTransport is not supported');
                        }
                        options = {
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: '*/*',
                            },
                            body: JSON.stringify(payload),
                            method: 'POST',
                        };
                        return [4 /*yield*/, fetch(serverUrl, options)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responsePayload = _a.sent();
                        return [2 /*return*/, this.buildResponse(responsePayload)];
                }
            });
        });
    };
    return FetchTransport;
}(BaseTransport));

var ApplicationContextProviderImpl = /** @class */ (function () {
    function ApplicationContextProviderImpl() {
    }
    ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
        return {
            versionName: this.versionName,
            language: getLanguage$1(),
            platform: 'Web',
            os: undefined,
            deviceModel: undefined,
        };
    };
    return ApplicationContextProviderImpl;
}());
var getLanguage$1 = function () {
    return ((typeof navigator !== 'undefined' &&
        ((navigator.languages && navigator.languages[0]) ||
            navigator.language)) ||
        '');
};

var EventBridgeImpl = /** @class */ (function () {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function (event) {
        if (!this.receiver) {
            if (this.queue.length < 512) {
                this.queue.push(event);
            }
        }
        else {
            this.receiver(event);
        }
    };
    EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function (event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}());

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function (obj1, obj2) {
    var primitive = ['string', 'number', 'boolean', 'undefined'];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) {
        return false;
    }
    for (var _i = 0, primitive_1 = primitive; _i < primitive_1.length; _i++) {
        var p = primitive_1[_i];
        if (p === typeA) {
            return obj1 === obj2;
        }
    }
    // check null
    if (obj1 == null && obj2 == null) {
        return true;
    }
    else if (obj1 == null || obj2 == null) {
        return false;
    }
    // if got here - objects
    if (obj1.length !== obj2.length) {
        return false;
    }
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) {
        return false;
    }
    if (isArrayA && isArrayB) {
        //arrays
        for (var i = 0; i < obj1.length; i++) {
            if (!isEqual(obj1[i], obj2[i])) {
                return false;
            }
        }
    }
    else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!isEqual(sorted1, sorted2)) {
            return false;
        }
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function (key) {
            if (!isEqual(obj1[key], obj2[key])) {
                result_1 = false;
            }
        });
        return result_1;
    }
    return true;
};

var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj);
        var i = ownProps.length;
        var resArray = new Array(i);
        while (i--) {
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }
        return resArray;
    };
}
var IdentityStoreImpl = /** @class */ (function () {
    function IdentityStoreImpl() {
        this.identity = { userProperties: {} };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var actingUserProperties = __assign({}, this.identity.userProperties);
        var actingIdentity = __assign(__assign({}, this.identity), { userProperties: actingUserProperties });
        return {
            setUserId: function (userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function (deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function (userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            setOptOut: function (optOut) {
                actingIdentity.optOut = optOut;
                return this;
            },
            updateUserProperties: function (actions) {
                var actingProperties = actingIdentity.userProperties || {};
                for (var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++) {
                    var _b = _a[_i], action = _b[0], properties = _b[1];
                    switch (action) {
                        case ID_OP_SET:
                            for (var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++) {
                                var _e = _d[_c], key = _e[0], value = _e[1];
                                actingProperties[key] = value;
                            }
                            break;
                        case ID_OP_UNSET:
                            for (var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++) {
                                var key = _g[_f];
                                delete actingProperties[key];
                            }
                            break;
                        case ID_OP_CLEAR_ALL:
                            actingProperties = {};
                            break;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function () {
                self.setIdentity(actingIdentity);
                return this;
            },
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function () {
        return __assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function (identity) {
        var originalIdentity = __assign({}, this.identity);
        this.identity = __assign({}, identity);
        if (!isEqual(originalIdentity, this.identity)) {
            this.listeners.forEach(function (listener) {
                listener(identity);
            });
        }
    };
    IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}());

var safeGlobal = typeof globalThis !== 'undefined'
    ? globalThis
    : typeof global !== 'undefined'
        ? global
        : self;

var AnalyticsConnector = /** @class */ (function () {
    function AnalyticsConnector() {
        this.identityStore = new IdentityStoreImpl();
        this.eventBridge = new EventBridgeImpl();
        this.applicationContextProvider = new ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function (instanceName) {
        if (!safeGlobal['analyticsConnectorInstances']) {
            safeGlobal['analyticsConnectorInstances'] = {};
        }
        if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
            safeGlobal['analyticsConnectorInstances'][instanceName] =
                new AnalyticsConnector();
        }
        return safeGlobal['analyticsConnectorInstances'][instanceName];
    };
    return AnalyticsConnector;
}());

var getAnalyticsConnector = function (instanceName) {
    if (instanceName === void 0) { instanceName = '$default_instance'; }
    return AnalyticsConnector.getInstance(instanceName);
};
var setConnectorUserId = function (userId, instanceName) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
var setConnectorDeviceId = function (deviceId, instanceName) {
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
};

var IdentityEventSender = /** @class */ (function () {
    function IdentityEventSender() {
        this.name = 'identity';
        this.type = 'before';
        this.identityStore = getAnalyticsConnector().identityStore;
    }
    IdentityEventSender.prototype.execute = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var userProperties;
            return __generator(this, function (_a) {
                userProperties = context.user_properties;
                if (userProperties) {
                    this.identityStore.editIdentity().updateUserProperties(userProperties).commit();
                }
                return [2 /*return*/, context];
            });
        });
    };
    IdentityEventSender.prototype.setup = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (config.instanceName) {
                    this.identityStore = getAnalyticsConnector(config.instanceName).identityStore;
                }
                return [2 /*return*/];
            });
        });
    };
    return IdentityEventSender;
}());

var getLanguage = function () {
    var _a, _b, _c, _d;
    if (typeof navigator === 'undefined')
        return '';
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var userLanguage = navigator.userLanguage;
    return (_d = (_c = (_b = (_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : navigator.language) !== null && _c !== void 0 ? _c : userLanguage) !== null && _d !== void 0 ? _d : '';
};

/**
 * Returns false if defaultTracking === false or if defaultTracking[event],
 * otherwise returns true
 */
var isTrackingEnabled = function (defaultTracking, event) {
    if (typeof defaultTracking === 'boolean') {
        return defaultTracking;
    }
    if ((defaultTracking === null || defaultTracking === void 0 ? void 0 : defaultTracking[event]) === false) {
        return false;
    }
    return true;
};
var isAttributionTrackingEnabled = function (defaultTracking) {
    return isTrackingEnabled(defaultTracking, 'attribution');
};
var isFileDownloadTrackingEnabled = function (defaultTracking) {
    return isTrackingEnabled(defaultTracking, 'fileDownloads');
};
var isFormInteractionTrackingEnabled = function (defaultTracking) {
    return isTrackingEnabled(defaultTracking, 'formInteractions');
};
var isPageViewTrackingEnabled = function (defaultTracking) {
    return isTrackingEnabled(defaultTracking, 'pageViews');
};
var isSessionTrackingEnabled = function (defaultTracking) {
    return isTrackingEnabled(defaultTracking, 'sessions');
};
var getPageViewTrackingConfig = function (config) {
    var trackOn = function () { return false; };
    var trackHistoryChanges = undefined;
    var eventType;
    var pageCounter = config.pageCounter;
    var isDefaultPageViewTrackingEnabled = isPageViewTrackingEnabled(config.defaultTracking);
    if (isDefaultPageViewTrackingEnabled) {
        trackOn = undefined;
        eventType = undefined;
        if (config.defaultTracking &&
            typeof config.defaultTracking === 'object' &&
            config.defaultTracking.pageViews &&
            typeof config.defaultTracking.pageViews === 'object') {
            if ('trackOn' in config.defaultTracking.pageViews) {
                trackOn = config.defaultTracking.pageViews.trackOn;
            }
            if ('trackHistoryChanges' in config.defaultTracking.pageViews) {
                trackHistoryChanges = config.defaultTracking.pageViews.trackHistoryChanges;
            }
            if ('eventType' in config.defaultTracking.pageViews && config.defaultTracking.pageViews.eventType) {
                eventType = config.defaultTracking.pageViews.eventType;
            }
        }
    }
    return {
        trackOn: trackOn,
        trackHistoryChanges: trackHistoryChanges,
        eventType: eventType,
        pageCounter: pageCounter,
    };
};
var getAttributionTrackingConfig = function (config) {
    if (isAttributionTrackingEnabled(config.defaultTracking) &&
        config.defaultTracking &&
        typeof config.defaultTracking === 'object' &&
        config.defaultTracking.attribution &&
        typeof config.defaultTracking.attribution === 'object') {
        return __assign$1({}, config.defaultTracking.attribution);
    }
    return {};
};

/**
 * Applies the proxied functions on the proxied amplitude snippet to an instance of the real object.
 * @ignore
 */
/**
 * Applies the proxied functions on the proxied object to an instance of the real object.
 * Used to convert proxied Identify and Revenue objects.
 */
var convertProxyObjectToRealObject = function (instance, queue) {
    for (var i = 0; i < queue.length; i++) {
        var _a = queue[i], name_1 = _a.name, args = _a.args, resolve = _a.resolve;
        var fn = instance && instance[name_1];
        if (typeof fn === 'function') {
            var result = fn.apply(instance, args);
            if (typeof resolve === 'function') {
                resolve(result === null || result === void 0 ? void 0 : result.promise);
            }
        }
    }
    return instance;
};
/**
 * Check if the param is snippet proxy
 */
var isInstanceProxy = function (instance) {
    var instanceProxy = instance;
    return instanceProxy && instanceProxy._q !== undefined;
};

var VERSION = '2.5.2';

var BROWSER_PLATFORM = 'Web';
var IP_ADDRESS = '$remote';
var Context = /** @class */ (function () {
    function Context() {
        this.name = '@amplitude/plugin-context-browser';
        this.type = 'before';
        this.library = "amplitude-ts/".concat(VERSION);
        /* istanbul ignore else */
        if (typeof navigator !== 'undefined') {
            this.userAgent = navigator.userAgent;
        }
    }
    Context.prototype.setup = function (config) {
        this.config = config;
        return Promise.resolve(undefined);
    };
    Context.prototype.execute = function (context) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var time, lastEventId, nextEventId, event;
            return __generator(this, function (_c) {
                time = new Date().getTime();
                lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
                nextEventId = (_b = context.event_id) !== null && _b !== void 0 ? _b : lastEventId + 1;
                this.config.lastEventId = nextEventId;
                if (!context.time) {
                    this.config.lastEventTime = time;
                }
                event = __assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1(__assign$1({ user_id: this.config.userId, device_id: this.config.deviceId, session_id: this.config.sessionId, time: time }, (this.config.appVersion && { app_version: this.config.appVersion })), (this.config.trackingOptions.platform && { platform: BROWSER_PLATFORM })), (this.config.trackingOptions.language && { language: getLanguage() })), (this.config.trackingOptions.ipAddress && { ip: IP_ADDRESS })), { insert_id: UUID(), partner_id: this.config.partnerId, plan: this.config.plan }), (this.config.ingestionMetadata && {
                    ingestion_metadata: {
                        source_name: this.config.ingestionMetadata.sourceName,
                        source_version: this.config.ingestionMetadata.sourceVersion,
                    },
                })), context), { event_id: nextEventId, library: this.library, user_agent: this.userAgent });
                return [2 /*return*/, event];
            });
        });
    };
    return Context;
}());

var BrowserStorage = /** @class */ (function () {
    function BrowserStorage(storage) {
        this.storage = storage;
    }
    BrowserStorage.prototype.isEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var random, testStorage, testKey, value;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        /* istanbul ignore if */
                        if (!this.storage) {
                            return [2 /*return*/, false];
                        }
                        random = String(Date.now());
                        testStorage = new BrowserStorage(this.storage);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, 5, 7]);
                        return [4 /*yield*/, testStorage.set(testKey, random)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, testStorage.get(testKey)];
                    case 3:
                        value = _b.sent();
                        return [2 /*return*/, value === random];
                    case 4:
                        _b.sent();
                        /* istanbul ignore next */
                        return [2 /*return*/, false];
                    case 5: return [4 /*yield*/, testStorage.remove(testKey)];
                    case 6:
                        _b.sent();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    BrowserStorage.prototype.get = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getRaw(key)];
                    case 1:
                        value = _b.sent();
                        if (!value) {
                            return [2 /*return*/, undefined];
                        }
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                        return [2 /*return*/, JSON.parse(value)];
                    case 2:
                        _b.sent();
                        console.error("[Amplitude] Error: Could not get value from storage");
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrowserStorage.prototype.getRaw = function (key) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, ((_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || undefined];
            });
        });
    };
    BrowserStorage.prototype.set = function (key, value) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 ? void 0 : _a.setItem(key, JSON.stringify(value));
                }
                catch (_c) {
                    //
                }
                return [2 /*return*/];
            });
        });
    };
    BrowserStorage.prototype.remove = function (key) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 ? void 0 : _a.removeItem(key);
                }
                catch (_c) {
                    //
                }
                return [2 /*return*/];
            });
        });
    };
    BrowserStorage.prototype.reset = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 ? void 0 : _a.clear();
                }
                catch (_c) {
                    //
                }
                return [2 /*return*/];
            });
        });
    };
    return BrowserStorage;
}());

var MAX_ARRAY_LENGTH = 1000;
var LocalStorage = /** @class */ (function (_super) {
    __extends(LocalStorage, _super);
    function LocalStorage(config) {
        var _this = this;
        var _a;
        _this = _super.call(this, (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.localStorage) || this;
        _this.loggerProvider = config === null || config === void 0 ? void 0 : config.loggerProvider;
        return _this;
    }
    LocalStorage.prototype.set = function (key, value) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var droppedEventsCount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(Array.isArray(value) && value.length > MAX_ARRAY_LENGTH)) return [3 /*break*/, 2];
                        droppedEventsCount = value.length - MAX_ARRAY_LENGTH;
                        return [4 /*yield*/, _super.prototype.set.call(this, key, value.slice(0, MAX_ARRAY_LENGTH))];
                    case 1:
                        _b.sent();
                        (_a = this.loggerProvider) === null || _a === void 0 ? void 0 : _a.error("Failed to save ".concat(droppedEventsCount, " events because the queue length exceeded ").concat(MAX_ARRAY_LENGTH, "."));
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, _super.prototype.set.call(this, key, value)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return LocalStorage;
}(BrowserStorage));

var SessionStorage = /** @class */ (function (_super) {
    __extends(SessionStorage, _super);
    function SessionStorage() {
        var _a;
        return _super.call(this, (_a = getGlobalScope()) === null || _a === void 0 ? void 0 : _a.sessionStorage) || this;
    }
    return SessionStorage;
}(BrowserStorage));

var XHRTransport = /** @class */ (function (_super) {
    __extends(XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            done: 4,
        };
        return _this;
    }
    XHRTransport.prototype.send = function (serverUrl, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        /* istanbul ignore if */
                        if (typeof XMLHttpRequest === 'undefined') {
                            reject(new Error('XHRTransport is not supported.'));
                        }
                        var xhr = new XMLHttpRequest();
                        xhr.open('POST', serverUrl, true);
                        xhr.onreadystatechange = function () {
                            if (xhr.readyState === _this.state.done) {
                                try {
                                    var responsePayload = xhr.responseText;
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                    var parsedResponsePayload = JSON.parse(responsePayload);
                                    var result = _this.buildResponse(parsedResponsePayload);
                                    resolve(result);
                                }
                                catch (e) {
                                    reject(e);
                                }
                            }
                        };
                        xhr.setRequestHeader('Content-Type', 'application/json');
                        xhr.setRequestHeader('Accept', '*/*');
                        xhr.send(JSON.stringify(payload));
                    })];
            });
        });
    };
    return XHRTransport;
}(BaseTransport));

var SendBeaconTransport = /** @class */ (function (_super) {
    __extends(SendBeaconTransport, _super);
    function SendBeaconTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SendBeaconTransport.prototype.send = function (serverUrl, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var globalScope = getGlobalScope();
                        /* istanbul ignore if */
                        if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator.sendBeacon)) {
                            throw new Error('SendBeaconTransport is not supported');
                        }
                        try {
                            var data = JSON.stringify(payload);
                            var success = globalScope.navigator.sendBeacon(serverUrl, JSON.stringify(payload));
                            if (success) {
                                return resolve(_this.buildResponse({
                                    code: 200,
                                    events_ingested: payload.events.length,
                                    payload_size_bytes: data.length,
                                    server_upload_time: Date.now(),
                                }));
                            }
                            return resolve(_this.buildResponse({ code: 500 }));
                        }
                        catch (e) {
                            reject(e);
                        }
                    })];
            });
        });
    };
    return SendBeaconTransport;
}(BaseTransport));

var parseLegacyCookies = function (apiKey, cookieStorage, deleteLegacyCookies) {
    if (deleteLegacyCookies === void 0) { deleteLegacyCookies = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var cookieName, cookies, _a, deviceId, userId, optOut, sessionId, lastEventTime, lastEventId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cookieName = getOldCookieName(apiKey);
                    return [4 /*yield*/, cookieStorage.getRaw(cookieName)];
                case 1:
                    cookies = _b.sent();
                    if (!cookies) {
                        return [2 /*return*/, {
                                optOut: false,
                            }];
                    }
                    if (!deleteLegacyCookies) return [3 /*break*/, 3];
                    return [4 /*yield*/, cookieStorage.remove(cookieName)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _a = __read(cookies.split('.'), 6), deviceId = _a[0], userId = _a[1], optOut = _a[2], sessionId = _a[3], lastEventTime = _a[4], lastEventId = _a[5];
                    return [2 /*return*/, {
                            deviceId: deviceId,
                            userId: decode(userId),
                            sessionId: parseTime(sessionId),
                            lastEventId: parseTime(lastEventId),
                            lastEventTime: parseTime(lastEventTime),
                            optOut: Boolean(optOut),
                        }];
            }
        });
    });
};
var parseTime = function (num) {
    var integer = parseInt(num, 32);
    if (isNaN(integer)) {
        return undefined;
    }
    return integer;
};
var decode = function (value) {
    if (!atob || !escape || !value) {
        return undefined;
    }
    try {
        return decodeURIComponent(escape(atob(value)));
    }
    catch (_a) {
        return undefined;
    }
};

var DEFAULT_EVENT_PREFIX = '[Amplitude]';
var DEFAULT_FORM_START_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Started");
var DEFAULT_FORM_SUBMIT_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Submitted");
var DEFAULT_FILE_DOWNLOAD_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " File Downloaded");
var DEFAULT_SESSION_START_EVENT = 'session_start';
var DEFAULT_SESSION_END_EVENT = 'session_end';
var FILE_EXTENSION = "".concat(DEFAULT_EVENT_PREFIX, " File Extension");
var FILE_NAME = "".concat(DEFAULT_EVENT_PREFIX, " File Name");
var LINK_ID = "".concat(DEFAULT_EVENT_PREFIX, " Link ID");
var LINK_TEXT = "".concat(DEFAULT_EVENT_PREFIX, " Link Text");
var LINK_URL = "".concat(DEFAULT_EVENT_PREFIX, " Link URL");
var FORM_ID = "".concat(DEFAULT_EVENT_PREFIX, " Form ID");
var FORM_NAME = "".concat(DEFAULT_EVENT_PREFIX, " Form Name");
var FORM_DESTINATION = "".concat(DEFAULT_EVENT_PREFIX, " Form Destination");
var DEFAULT_IDENTITY_STORAGE = 'cookie';
var DEFAULT_SERVER_ZONE = 'US';

// Exported for testing purposes only. Do not expose to public interface.
var BrowserConfig = /** @class */ (function (_super) {
    __extends(BrowserConfig, _super);
    function BrowserConfig(apiKey, appVersion, cookieStorage, cookieOptions, defaultTracking, deviceId, flushIntervalMillis, flushMaxRetries, flushQueueSize, identityStorage, ingestionMetadata, instanceName, lastEventId, lastEventTime, loggerProvider, logLevel, minIdLength, offline, optOut, partnerId, plan, serverUrl, serverZone, sessionId, sessionTimeout, storageProvider, trackingOptions, transport, useBatch, userId, pageCounter) {
        if (cookieStorage === void 0) { cookieStorage = new MemoryStorage(); }
        if (cookieOptions === void 0) { cookieOptions = {
            domain: '',
            expiration: 365,
            sameSite: 'Lax',
            secure: false,
            upgrade: true,
        }; }
        if (flushIntervalMillis === void 0) { flushIntervalMillis = 1000; }
        if (flushMaxRetries === void 0) { flushMaxRetries = 5; }
        if (flushQueueSize === void 0) { flushQueueSize = 30; }
        if (identityStorage === void 0) { identityStorage = DEFAULT_IDENTITY_STORAGE; }
        if (loggerProvider === void 0) { loggerProvider = new Logger(); }
        if (logLevel === void 0) { logLevel = LogLevel.Warn; }
        if (offline === void 0) { offline = false; }
        if (optOut === void 0) { optOut = false; }
        if (serverUrl === void 0) { serverUrl = ''; }
        if (serverZone === void 0) { serverZone = DEFAULT_SERVER_ZONE; }
        if (sessionTimeout === void 0) { sessionTimeout = 30 * 60 * 1000; }
        if (storageProvider === void 0) { storageProvider = new LocalStorage({ loggerProvider: loggerProvider }); }
        if (trackingOptions === void 0) { trackingOptions = {
            ipAddress: true,
            language: true,
            platform: true,
        }; }
        if (transport === void 0) { transport = 'fetch'; }
        if (useBatch === void 0) { useBatch = false; }
        var _this = _super.call(this, { apiKey: apiKey, storageProvider: storageProvider, transportProvider: createTransport(transport) }) || this;
        _this.apiKey = apiKey;
        _this.appVersion = appVersion;
        _this.cookieOptions = cookieOptions;
        _this.defaultTracking = defaultTracking;
        _this.flushIntervalMillis = flushIntervalMillis;
        _this.flushMaxRetries = flushMaxRetries;
        _this.flushQueueSize = flushQueueSize;
        _this.identityStorage = identityStorage;
        _this.ingestionMetadata = ingestionMetadata;
        _this.instanceName = instanceName;
        _this.loggerProvider = loggerProvider;
        _this.logLevel = logLevel;
        _this.minIdLength = minIdLength;
        _this.offline = offline;
        _this.partnerId = partnerId;
        _this.plan = plan;
        _this.serverUrl = serverUrl;
        _this.serverZone = serverZone;
        _this.sessionTimeout = sessionTimeout;
        _this.storageProvider = storageProvider;
        _this.trackingOptions = trackingOptions;
        _this.transport = transport;
        _this.useBatch = useBatch;
        _this._optOut = false;
        _this._cookieStorage = cookieStorage;
        _this.deviceId = deviceId;
        _this.lastEventId = lastEventId;
        _this.lastEventTime = lastEventTime;
        _this.optOut = optOut;
        _this.sessionId = sessionId;
        _this.pageCounter = pageCounter;
        _this.userId = userId;
        _this.loggerProvider.enable(_this.logLevel);
        return _this;
    }
    Object.defineProperty(BrowserConfig.prototype, "cookieStorage", {
        get: function () {
            return this._cookieStorage;
        },
        set: function (cookieStorage) {
            if (this._cookieStorage !== cookieStorage) {
                this._cookieStorage = cookieStorage;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "deviceId", {
        get: function () {
            return this._deviceId;
        },
        set: function (deviceId) {
            if (this._deviceId !== deviceId) {
                this._deviceId = deviceId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        set: function (userId) {
            if (this._userId !== userId) {
                this._userId = userId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "sessionId", {
        get: function () {
            return this._sessionId;
        },
        set: function (sessionId) {
            if (this._sessionId !== sessionId) {
                this._sessionId = sessionId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "optOut", {
        get: function () {
            return this._optOut;
        },
        set: function (optOut) {
            if (this._optOut !== optOut) {
                this._optOut = optOut;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventTime", {
        get: function () {
            return this._lastEventTime;
        },
        set: function (lastEventTime) {
            if (this._lastEventTime !== lastEventTime) {
                this._lastEventTime = lastEventTime;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventId", {
        get: function () {
            return this._lastEventId;
        },
        set: function (lastEventId) {
            if (this._lastEventId !== lastEventId) {
                this._lastEventId = lastEventId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "pageCounter", {
        get: function () {
            return this._pageCounter;
        },
        set: function (pageCounter) {
            if (this._pageCounter !== pageCounter) {
                this._pageCounter = pageCounter;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    BrowserConfig.prototype.updateStorage = function () {
        var cache = {
            deviceId: this._deviceId,
            userId: this._userId,
            sessionId: this._sessionId,
            optOut: this._optOut,
            lastEventTime: this._lastEventTime,
            lastEventId: this._lastEventId,
            pageCounter: this._pageCounter,
        };
        void this.cookieStorage.set(getCookieName(this.apiKey), cache);
    };
    return BrowserConfig;
}(Config));
var useBrowserConfig = function (apiKey, options, amplitudeInstance) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var identityStorage, cookieOptions, _a, _b, cookieStorage, legacyCookies, previousCookies, queryParams, deviceId, lastEventId, lastEventTime, optOut, sessionId, userId, trackingOptions, pageCounter;
        var _c;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        return __generator(this, function (_2) {
            switch (_2.label) {
                case 0:
                    identityStorage = options.identityStorage || DEFAULT_IDENTITY_STORAGE;
                    _c = {};
                    if (!(identityStorage !== DEFAULT_IDENTITY_STORAGE)) return [3 /*break*/, 1];
                    _a = '';
                    return [3 /*break*/, 5];
                case 1:
                    if (!((_e = (_d = options.cookieOptions) === null || _d === void 0 ? void 0 : _d.domain) !== null && _e !== void 0)) return [3 /*break*/, 2];
                    _b = _e;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, getTopLevelDomain()];
                case 3:
                    _b = (_2.sent());
                    _2.label = 4;
                case 4:
                    _a = _b;
                    _2.label = 5;
                case 5:
                    cookieOptions = __assign$1.apply(void 0, [(_c.domain = _a, _c.expiration = 365, _c.sameSite = 'Lax', _c.secure = false, _c.upgrade = true, _c), options.cookieOptions]);
                    cookieStorage = createCookieStorage(options.identityStorage, cookieOptions);
                    return [4 /*yield*/, parseLegacyCookies(apiKey, cookieStorage, (_g = (_f = options.cookieOptions) === null || _f === void 0 ? void 0 : _f.upgrade) !== null && _g !== void 0 ? _g : true)];
                case 6:
                    legacyCookies = _2.sent();
                    return [4 /*yield*/, cookieStorage.get(getCookieName(apiKey))];
                case 7:
                    previousCookies = _2.sent();
                    queryParams = getQueryParams();
                    deviceId = (_l = (_k = (_j = (_h = options.deviceId) !== null && _h !== void 0 ? _h : queryParams.deviceId) !== null && _j !== void 0 ? _j : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _k !== void 0 ? _k : legacyCookies.deviceId) !== null && _l !== void 0 ? _l : UUID();
                    lastEventId = (_m = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventId) !== null && _m !== void 0 ? _m : legacyCookies.lastEventId;
                    lastEventTime = (_o = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventTime) !== null && _o !== void 0 ? _o : legacyCookies.lastEventTime;
                    optOut = (_q = (_p = options.optOut) !== null && _p !== void 0 ? _p : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.optOut) !== null && _q !== void 0 ? _q : legacyCookies.optOut;
                    sessionId = (_r = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.sessionId) !== null && _r !== void 0 ? _r : legacyCookies.sessionId;
                    userId = (_t = (_s = options.userId) !== null && _s !== void 0 ? _s : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _t !== void 0 ? _t : legacyCookies.userId;
                    amplitudeInstance.previousSessionDeviceId = (_u = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _u !== void 0 ? _u : legacyCookies.deviceId;
                    amplitudeInstance.previousSessionUserId = (_v = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _v !== void 0 ? _v : legacyCookies.userId;
                    trackingOptions = {
                        ipAddress: (_x = (_w = options.trackingOptions) === null || _w === void 0 ? void 0 : _w.ipAddress) !== null && _x !== void 0 ? _x : true,
                        language: (_z = (_y = options.trackingOptions) === null || _y === void 0 ? void 0 : _y.language) !== null && _z !== void 0 ? _z : true,
                        platform: (_1 = (_0 = options.trackingOptions) === null || _0 === void 0 ? void 0 : _0.platform) !== null && _1 !== void 0 ? _1 : true,
                    };
                    pageCounter = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.pageCounter;
                    return [2 /*return*/, new BrowserConfig(apiKey, options.appVersion, cookieStorage, cookieOptions, options.defaultTracking, deviceId, options.flushIntervalMillis, options.flushMaxRetries, options.flushQueueSize, identityStorage, options.ingestionMetadata, options.instanceName, lastEventId, lastEventTime, options.loggerProvider, options.logLevel, options.minIdLength, options.offline, optOut, options.partnerId, options.plan, options.serverUrl, options.serverZone, sessionId, options.sessionTimeout, options.storageProvider, trackingOptions, options.transport, options.useBatch, userId, pageCounter)];
            }
        });
    });
};
var createCookieStorage = function (identityStorage, cookieOptions) {
    if (identityStorage === void 0) { identityStorage = DEFAULT_IDENTITY_STORAGE; }
    if (cookieOptions === void 0) { cookieOptions = {}; }
    switch (identityStorage) {
        case 'localStorage':
            return new LocalStorage();
        case 'sessionStorage':
            return new SessionStorage();
        case 'none':
            return new MemoryStorage();
        case 'cookie':
        default:
            return new CookieStorage(__assign$1(__assign$1({}, cookieOptions), { expirationDays: cookieOptions.expiration }));
    }
};
var createTransport = function (transport) {
    if (transport === 'xhr') {
        return new XHRTransport();
    }
    if (transport === 'beacon') {
        return new SendBeaconTransport();
    }
    return new FetchTransport();
};
var getTopLevelDomain = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var host, parts, levels, storageKey, i, i, domain, options, storage, value;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new CookieStorage().isEnabled()];
            case 1:
                if (!(_a.sent()) || (!url && typeof location === 'undefined')) {
                    return [2 /*return*/, ''];
                }
                host = url !== null && url !== void 0 ? url : location.hostname;
                parts = host.split('.');
                levels = [];
                storageKey = 'AMP_TLDTEST';
                for (i = parts.length - 2; i >= 0; --i) {
                    levels.push(parts.slice(i).join('.'));
                }
                i = 0;
                _a.label = 2;
            case 2:
                if (!(i < levels.length)) return [3 /*break*/, 7];
                domain = levels[i];
                options = { domain: '.' + domain };
                storage = new CookieStorage(options);
                return [4 /*yield*/, storage.set(storageKey, 1)];
            case 3:
                _a.sent();
                return [4 /*yield*/, storage.get(storageKey)];
            case 4:
                value = _a.sent();
                if (!value) return [3 /*break*/, 6];
                return [4 /*yield*/, storage.remove(storageKey)];
            case 5:
                _a.sent();
                return [2 /*return*/, '.' + domain];
            case 6:
                i++;
                return [3 /*break*/, 2];
            case 7: return [2 /*return*/, ''];
        }
    });
}); };

var getStorageKey = function (apiKey, postKey, limit) {
    if (postKey === void 0) { postKey = ''; }
    if (limit === void 0) { limit = 10; }
    return [AMPLITUDE_PREFIX, postKey, apiKey.substring(0, limit)].filter(Boolean).join('_');
};
var domainWithoutSubdomain = function (domain) {
    var parts = domain.split('.');
    if (parts.length <= 2) {
        return domain;
    }
    return parts.slice(parts.length - 2, parts.length).join('.');
};
//Direct traffic mean no external referral, no UTMs, no click-ids, and no other customer identified marketing campaign url params.
var isDirectTraffic = function (current) {
    return Object.values(current).every(function (value) { return !value; });
};
var isNewCampaign = function (current, previous, options, isNewSession) {
    if (isNewSession === void 0) { isNewSession = true; }
    current.referrer; var referring_domain = current.referring_domain, currentCampaign = __rest(current, ["referrer", "referring_domain"]);
    var _a = previous || {}; _a.referrer; var prevReferringDomain = _a.referring_domain, previousCampaign = __rest(_a, ["referrer", "referring_domain"]);
    if (isExcludedReferrer(options.excludeReferrers, current.referring_domain)) {
        return false;
    }
    //In the same session, direct traffic should not override or unset any persisting query params
    if (!isNewSession && isDirectTraffic(current) && previous) {
        return false;
    }
    var hasNewCampaign = JSON.stringify(currentCampaign) !== JSON.stringify(previousCampaign);
    var hasNewDomain = domainWithoutSubdomain(referring_domain || '') !== domainWithoutSubdomain(prevReferringDomain || '');
    return !previous || hasNewCampaign || hasNewDomain;
};
var isExcludedReferrer = function (excludeReferrers, referringDomain) {
    if (excludeReferrers === void 0) { excludeReferrers = []; }
    if (referringDomain === void 0) { referringDomain = ''; }
    return excludeReferrers.some(function (value) {
        return value instanceof RegExp ? value.test(referringDomain) : value === referringDomain;
    });
};
var createCampaignEvent = function (campaign, options) {
    var campaignParameters = __assign$1(__assign$1({}, BASE_CAMPAIGN), campaign);
    var identifyEvent = Object.entries(campaignParameters).reduce(function (identify, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        identify.setOnce("initial_".concat(key), (_b = value !== null && value !== void 0 ? value : options.initialEmptyValue) !== null && _b !== void 0 ? _b : 'EMPTY');
        if (value) {
            return identify.set(key, value);
        }
        return identify.unset(key);
    }, new Identify());
    return createIdentifyEvent(identifyEvent);
};
var getDefaultExcludedReferrers = function (cookieDomain) {
    var domain = cookieDomain;
    if (domain) {
        if (domain.startsWith('.')) {
            domain = domain.substring(1);
        }
        return [new RegExp("".concat(domain.replace('.', '\\.'), "$"))];
    }
    return [];
};

var webAttributionPlugin = function (options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var plugin = {
        name: '@amplitude/plugin-web-attribution-browser',
        type: 'before',
        setup: function (config, amplitude) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var pluginConfig, storage, storageKey, _b, currentCampaign, previousCampaign, isEventInNewSession, campaignEvent;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            pluginConfig = __assign$1({ initialEmptyValue: 'EMPTY', resetSessionOnNewCampaign: false, excludeReferrers: getDefaultExcludedReferrers((_a = config.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain) }, options);
                            config.loggerProvider.log('Installing @amplitude/plugin-web-attribution-browser.');
                            storage = config.cookieStorage;
                            storageKey = getStorageKey(config.apiKey, 'MKTG');
                            return [4 /*yield*/, Promise.all([
                                    new CampaignParser().parse(),
                                    storage.get(storageKey),
                                ])];
                        case 1:
                            _b = __read.apply(void 0, [_c.sent(), 2]), currentCampaign = _b[0], previousCampaign = _b[1];
                            isEventInNewSession = isNewSession(config.sessionTimeout, config.lastEventTime);
                            if (isNewCampaign(currentCampaign, previousCampaign, pluginConfig, isEventInNewSession)) {
                                if (pluginConfig.resetSessionOnNewCampaign) {
                                    amplitude.setSessionId(Date.now());
                                    config.loggerProvider.log('Created a new session for new campaign.');
                                }
                                config.loggerProvider.log('Tracking attribution.');
                                campaignEvent = createCampaignEvent(currentCampaign, pluginConfig);
                                amplitude.track(campaignEvent);
                                void storage.set(storageKey, currentCampaign);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        execute: function (event) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, event];
        }); }); },
    };
    return plugin;
};

var omitUndefined = function (input) {
    var obj = {};
    for (var key in input) {
        var val = input[key];
        if (val) {
            obj[key] = val;
        }
    }
    return obj;
};

var pageViewTrackingPlugin = function (options) {
    if (options === void 0) { options = {}; }
    var amplitude;
    var globalScope = getGlobalScope();
    var loggerProvider = undefined;
    var pushState;
    var localConfig;
    var createPageViewEvent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        var _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    localConfig.pageCounter = !localConfig.pageCounter ? 1 : localConfig.pageCounter + 1;
                    _b = {
                        event_type: (_c = options.eventType) !== null && _c !== void 0 ? _c : '[Amplitude] Page Viewed'
                    };
                    _a = [{}];
                    return [4 /*yield*/, getCampaignParams()];
                case 1: return [2 /*return*/, (_b.event_properties = __assign$1.apply(void 0, [__assign$1.apply(void 0, _a.concat([(_d.sent())])), { '[Amplitude] Page Domain': 
                            /* istanbul ignore next */ (typeof location !== 'undefined' && location.hostname) || '', '[Amplitude] Page Location': 
                            /* istanbul ignore next */ (typeof location !== 'undefined' && location.href) || '', '[Amplitude] Page Path': 
                            /* istanbul ignore next */ (typeof location !== 'undefined' && location.pathname) || '', '[Amplitude] Page Title': /* istanbul ignore next */ (typeof document !== 'undefined' && document.title) || '', '[Amplitude] Page URL': 
                            /* istanbul ignore next */ (typeof location !== 'undefined' && location.href.split('?')[0]) || '', '[Amplitude] Page Counter': localConfig.pageCounter }]),
                        _b)];
            }
        });
    }); };
    var shouldTrackOnPageLoad = function () {
        return typeof options.trackOn === 'undefined' || (typeof options.trackOn === 'function' && options.trackOn());
    };
    /* istanbul ignore next */
    var previousURL = typeof location !== 'undefined' ? location.href : null;
    var trackHistoryPageView = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newURL, shouldTrackPageView, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    newURL = location.href;
                    shouldTrackPageView = shouldTrackHistoryPageView(options.trackHistoryChanges, newURL, previousURL || '') && shouldTrackOnPageLoad();
                    // Note: Update `previousURL` in the same clock tick as `shouldTrackHistoryPageView()`
                    // This was previously done after `amplitude?.track(await createPageViewEvent());` and
                    // causes a concurrency issue where app triggers `pushState` twice with the same URL target
                    // but `previousURL` is only updated after the second `pushState` producing two page viewed events
                    previousURL = newURL;
                    if (!shouldTrackPageView) return [3 /*break*/, 4];
                    /* istanbul ignore next */
                    loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log('Tracking page view event');
                    if (!(amplitude === null || amplitude === void 0)) return [3 /*break*/, 1];
                    return [3 /*break*/, 3];
                case 1:
                    _c = (_b = amplitude).track;
                    return [4 /*yield*/, createPageViewEvent()];
                case 2:
                    _c.apply(_b, [_d.sent()]);
                    _d.label = 3;
                case 3:
                    _d.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /* istanbul ignore next */
    var trackHistoryPageViewWrapper = function () {
        void trackHistoryPageView();
    };
    var plugin = {
        name: '@amplitude/plugin-page-view-tracking-browser',
        type: 'enrichment',
        setup: function (config, client) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        amplitude = client;
                        localConfig = config;
                        loggerProvider = config.loggerProvider;
                        loggerProvider.log('Installing @amplitude/plugin-page-view-tracking-browser');
                        if (globalScope) {
                            globalScope.addEventListener('popstate', trackHistoryPageViewWrapper);
                            // Save reference to original push state, to be used in teardown
                            // eslint-disable-next-line @typescript-eslint/unbound-method
                            pushState = globalScope.history.pushState;
                            /* istanbul ignore next */
                            // There is no global browser listener for changes to history, so we have
                            // to modify pushState directly.
                            // https://stackoverflow.com/a/64927639
                            // eslint-disable-next-line @typescript-eslint/unbound-method
                            globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                                apply: function (target, thisArg, _a) {
                                    var _b = __read(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                                    target.apply(thisArg, [state, unused, url]);
                                    void trackHistoryPageView();
                                },
                            });
                        }
                        if (!shouldTrackOnPageLoad()) return [3 /*break*/, 2];
                        loggerProvider.log('Tracking page view event');
                        _b = (_a = amplitude).track;
                        return [4 /*yield*/, createPageViewEvent()];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        execute: function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var pageViewEvent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(options.trackOn === 'attribution' && isCampaignEvent(event))) return [3 /*break*/, 2];
                        /* istanbul ignore next */ // loggerProvider should be defined by the time execute is invoked
                        loggerProvider === null || loggerProvider === void 0 ? void 0 : loggerProvider.log('Enriching campaign event to page view event with campaign parameters');
                        return [4 /*yield*/, createPageViewEvent()];
                    case 1:
                        pageViewEvent = _a.sent();
                        event.event_type = pageViewEvent.event_type;
                        event.event_properties = __assign$1(__assign$1({}, event.event_properties), pageViewEvent.event_properties);
                        _a.label = 2;
                    case 2: return [2 /*return*/, event];
                }
            });
        }); },
        teardown: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (globalScope) {
                    globalScope.removeEventListener('popstate', trackHistoryPageViewWrapper);
                    if (pushState) {
                        globalScope.history.pushState = pushState;
                    }
                }
                return [2 /*return*/];
            });
        }); },
    };
    return plugin;
};
var getCampaignParams = function () { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
    switch (_b.label) {
        case 0:
            _a = omitUndefined;
            return [4 /*yield*/, new CampaignParser().parse()];
        case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
    }
}); }); };
var isCampaignEvent = function (event) {
    if (event.event_type === '$identify' && event.user_properties) {
        var properties = event.user_properties;
        var $set = properties[IdentifyOperation.SET] || {};
        var $unset = properties[IdentifyOperation.UNSET] || {};
        var userProperties_1 = __spreadArray(__spreadArray([], __read(Object.keys($set)), false), __read(Object.keys($unset)), false);
        return Object.keys(BASE_CAMPAIGN).every(function (value) { return userProperties_1.includes(value); });
    }
    return false;
};
var shouldTrackHistoryPageView = function (trackingOption, newURL, oldURL) {
    switch (trackingOption) {
        case 'pathOnly':
            return newURL.split('?')[0] !== oldURL.split('?')[0];
        default:
            return newURL !== oldURL;
    }
};

var formInteractionTracking = function () {
    var observer;
    var eventListeners = [];
    var addEventListener = function (element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler,
        });
    };
    var removeClickListeners = function () {
        eventListeners.forEach(function (_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */
            element === null || element === void 0 ? void 0 : element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-form-interaction-tracking-browser';
    var type = 'enrichment';
    var setup = function (config, amplitude) { return __awaiter(void 0, void 0, void 0, function () {
        var addFormInteractionListener, forms;
        return __generator(this, function (_a) {
            /* istanbul ignore if */
            if (!amplitude) {
                // TODO: Add required minimum version of @amplitude/analytics-browser
                config.loggerProvider.warn('Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.');
                return [2 /*return*/];
            }
            /* istanbul ignore if */
            if (typeof document === 'undefined') {
                return [2 /*return*/];
            }
            addFormInteractionListener = function (form) {
                var hasFormChanged = false;
                addEventListener(form, 'change', function () {
                    var _a;
                    if (!hasFormChanged) {
                        amplitude.track(DEFAULT_FORM_START_EVENT, (_a = {},
                            _a[FORM_ID] = stringOrUndefined(form.id),
                            _a[FORM_NAME] = stringOrUndefined(form.name),
                            _a[FORM_DESTINATION] = form.action,
                            _a));
                    }
                    hasFormChanged = true;
                });
                addEventListener(form, 'submit', function () {
                    var _a, _b;
                    if (!hasFormChanged) {
                        amplitude.track(DEFAULT_FORM_START_EVENT, (_a = {},
                            _a[FORM_ID] = stringOrUndefined(form.id),
                            _a[FORM_NAME] = stringOrUndefined(form.name),
                            _a[FORM_DESTINATION] = form.action,
                            _a));
                    }
                    amplitude.track(DEFAULT_FORM_SUBMIT_EVENT, (_b = {},
                        _b[FORM_ID] = stringOrUndefined(form.id),
                        _b[FORM_NAME] = stringOrUndefined(form.name),
                        _b[FORM_DESTINATION] = form.action,
                        _b));
                    hasFormChanged = false;
                });
            };
            forms = Array.from(document.getElementsByTagName('form'));
            forms.forEach(addFormInteractionListener);
            // Adds listener to anchor tags added after initial load
            /* istanbul ignore else */
            if (typeof MutationObserver !== 'undefined') {
                observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        mutation.addedNodes.forEach(function (node) {
                            if (node.nodeName === 'FORM') {
                                addFormInteractionListener(node);
                            }
                            if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') {
                                Array.from(node.querySelectorAll('form')).map(addFormInteractionListener);
                            }
                        });
                    });
                });
                observer.observe(document.body, {
                    subtree: true,
                    childList: true,
                });
            }
            return [2 /*return*/];
        });
    }); };
    var execute = function (event) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, event];
    }); }); };
    var teardown = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            removeClickListeners();
            return [2 /*return*/];
        });
    }); };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown,
    };
};
var stringOrUndefined = function (name) {
    /* istanbul ignore if */
    if (typeof name !== 'string') {
        // We found instances where the value of `name` is an Element and not a string.
        // Elements may have circular references and would throw an error when passed to `JSON.stringify(...)`.
        // If a non-string value is seen, assume there is no value.
        return undefined;
    }
    return name;
};

var fileDownloadTracking = function () {
    var observer;
    var eventListeners = [];
    var addEventListener = function (element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler,
        });
    };
    var removeClickListeners = function () {
        eventListeners.forEach(function (_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */
            element === null || element === void 0 ? void 0 : element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-file-download-tracking-browser';
    var type = 'enrichment';
    var setup = function (config, amplitude) { return __awaiter(void 0, void 0, void 0, function () {
        var addFileDownloadListener, ext, links;
        return __generator(this, function (_a) {
            /* istanbul ignore if */
            if (!amplitude) {
                // TODO: Add required minimum version of @amplitude/analytics-browser
                config.loggerProvider.warn('File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.');
                return [2 /*return*/];
            }
            /* istanbul ignore if */
            if (typeof document === 'undefined') {
                return [2 /*return*/];
            }
            addFileDownloadListener = function (a) {
                var url;
                try {
                    // eslint-disable-next-line no-restricted-globals
                    url = new URL(a.href, window.location.href);
                }
                catch (_a) {
                    /* istanbul ignore next */
                    return;
                }
                var result = ext.exec(url.href);
                var fileExtension = result === null || result === void 0 ? void 0 : result[1];
                if (fileExtension) {
                    addEventListener(a, 'click', function () {
                        var _a;
                        if (fileExtension) {
                            amplitude.track(DEFAULT_FILE_DOWNLOAD_EVENT, (_a = {},
                                _a[FILE_EXTENSION] = fileExtension,
                                _a[FILE_NAME] = url.pathname,
                                _a[LINK_ID] = a.id,
                                _a[LINK_TEXT] = a.text,
                                _a[LINK_URL] = a.href,
                                _a));
                        }
                    });
                }
            };
            ext = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)$/;
            links = Array.from(document.getElementsByTagName('a'));
            links.forEach(addFileDownloadListener);
            // Adds listener to anchor tags added after initial load
            /* istanbul ignore else */
            if (typeof MutationObserver !== 'undefined') {
                observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {
                        mutation.addedNodes.forEach(function (node) {
                            if (node.nodeName === 'A') {
                                addFileDownloadListener(node);
                            }
                            if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') {
                                Array.from(node.querySelectorAll('a')).map(addFileDownloadListener);
                            }
                        });
                    });
                });
                observer.observe(document.body, {
                    subtree: true,
                    childList: true,
                });
            }
            return [2 /*return*/];
        });
    }); };
    var execute = function (event) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, event];
    }); }); };
    var teardown = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            removeClickListeners();
            return [2 /*return*/];
        });
    }); };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown,
    };
};

var notified = false;
var detNotify = function (config) {
    if (notified || config.defaultTracking !== undefined) {
        return;
    }
    var message = "`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.";
    config.loggerProvider.warn(message);
    notified = true;
};

var networkConnectivityCheckerPlugin = function () {
    var name = '@amplitude/plugin-network-checker-browser';
    var type = 'before';
    var globalScope = getGlobalScope();
    var eventListeners = [];
    var addNetworkListener = function (type, handler) {
        if (globalScope) {
            globalScope.addEventListener(type, handler);
            eventListeners.push({
                type: type,
                handler: handler,
            });
        }
    };
    var removeNetworkListeners = function () {
        eventListeners.forEach(function (_a) {
            var type = _a.type, handler = _a.handler;
            if (globalScope) {
                globalScope.removeEventListener(type, handler);
            }
        });
        eventListeners = [];
    };
    var setup = function (config, amplitude) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            config.offline = !navigator.onLine;
            addNetworkListener('online', function () {
                config.loggerProvider.debug('Network connectivity changed to online.');
                config.offline = false;
                // Flush immediately will cause ERR_NETWORK_CHANGED
                setTimeout(function () {
                    amplitude.flush();
                }, config.flushIntervalMillis);
            });
            addNetworkListener('offline', function () {
                config.loggerProvider.debug('Network connectivity changed to offline.');
                config.offline = true;
            });
            return [2 /*return*/];
        });
    }); };
    var teardown = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            removeNetworkListeners();
            return [2 /*return*/];
        });
    }); };
    return {
        name: name,
        type: type,
        setup: setup,
        teardown: teardown,
    };
};

var AmplitudeBrowser = /** @class */ (function (_super) {
    __extends(AmplitudeBrowser, _super);
    function AmplitudeBrowser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AmplitudeBrowser.prototype.init = function (apiKey, userIdOrOptions, maybeOptions) {
        if (apiKey === void 0) { apiKey = ''; }
        var userId;
        var options;
        if (arguments.length > 2) {
            userId = userIdOrOptions;
            options = maybeOptions;
        }
        else {
            if (typeof userIdOrOptions === 'string') {
                userId = userIdOrOptions;
                options = undefined;
            }
            else {
                userId = userIdOrOptions === null || userIdOrOptions === void 0 ? void 0 : userIdOrOptions.userId;
                options = userIdOrOptions;
            }
        }
        return returnWrapper(this._init(__assign$1(__assign$1({}, options), { userId: userId, apiKey: apiKey })));
    };
    AmplitudeBrowser.prototype._init = function (options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var browserOptions, connector, attributionTrackingOptions, webAttribution;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        // Step 1: Block concurrent initialization
                        if (this.initializing) {
                            return [2 /*return*/];
                        }
                        this.initializing = true;
                        return [4 /*yield*/, useBrowserConfig(options.apiKey, options, this)];
                    case 1:
                        browserOptions = _c.sent();
                        return [4 /*yield*/, _super.prototype._init.call(this, browserOptions)];
                    case 2:
                        _c.sent();
                        // Step 3: Set session ID
                        // Priority 1: `options.sessionId`
                        // Priority 2: last known sessionId from user identity storage
                        // Default: `Date.now()`
                        // Session ID is handled differently than device ID and user ID due to session events
                        this.setSessionId((_b = (_a = options.sessionId) !== null && _a !== void 0 ? _a : this.config.sessionId) !== null && _b !== void 0 ? _b : Date.now());
                        connector = getAnalyticsConnector(options.instanceName);
                        connector.identityStore.setIdentity({
                            userId: this.config.userId,
                            deviceId: this.config.deviceId,
                        });
                        if (!(this.config.offline !== OfflineDisabled)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.add(networkConnectivityCheckerPlugin()).promise];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4: return [4 /*yield*/, this.add(new Destination()).promise];
                    case 5:
                        _c.sent();
                        return [4 /*yield*/, this.add(new Context()).promise];
                    case 6:
                        _c.sent();
                        return [4 /*yield*/, this.add(new IdentityEventSender()).promise];
                    case 7:
                        _c.sent();
                        // Notify if DET is enabled
                        detNotify(this.config);
                        if (!isFileDownloadTrackingEnabled(this.config.defaultTracking)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.add(fileDownloadTracking()).promise];
                    case 8:
                        _c.sent();
                        _c.label = 9;
                    case 9:
                        if (!isFormInteractionTrackingEnabled(this.config.defaultTracking)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.add(formInteractionTracking()).promise];
                    case 10:
                        _c.sent();
                        _c.label = 11;
                    case 11:
                        if (!isAttributionTrackingEnabled(this.config.defaultTracking)) return [3 /*break*/, 13];
                        attributionTrackingOptions = getAttributionTrackingConfig(this.config);
                        webAttribution = webAttributionPlugin(attributionTrackingOptions);
                        return [4 /*yield*/, this.add(webAttribution).promise];
                    case 12:
                        _c.sent();
                        _c.label = 13;
                    case 13:
                        if (!isPageViewTrackingEnabled(this.config.defaultTracking)) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.add(pageViewTrackingPlugin(getPageViewTrackingConfig(this.config))).promise];
                    case 14:
                        _c.sent();
                        _c.label = 15;
                    case 15:
                        this.initializing = false;
                        // Step 6: Run queued dispatch functions
                        return [4 /*yield*/, this.runQueuedFunctions('dispatchQ')];
                    case 16:
                        // Step 6: Run queued dispatch functions
                        _c.sent();
                        // Step 7: Add the event receiver after running remaining queued functions.
                        connector.eventBridge.setEventReceiver(function (event) {
                            void _this.track(event.eventType, event.eventProperties);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AmplitudeBrowser.prototype.getUserId = function () {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.userId;
    };
    AmplitudeBrowser.prototype.setUserId = function (userId) {
        if (!this.config) {
            this.q.push(this.setUserId.bind(this, userId));
            return;
        }
        if (userId !== this.config.userId || userId === undefined) {
            this.config.userId = userId;
            setConnectorUserId(userId, this.config.instanceName);
        }
    };
    AmplitudeBrowser.prototype.getDeviceId = function () {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.deviceId;
    };
    AmplitudeBrowser.prototype.setDeviceId = function (deviceId) {
        if (!this.config) {
            this.q.push(this.setDeviceId.bind(this, deviceId));
            return;
        }
        this.config.deviceId = deviceId;
        setConnectorDeviceId(deviceId, this.config.instanceName);
    };
    AmplitudeBrowser.prototype.reset = function () {
        this.setDeviceId(UUID());
        this.setUserId(undefined);
    };
    AmplitudeBrowser.prototype.getSessionId = function () {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.sessionId;
    };
    AmplitudeBrowser.prototype.setSessionId = function (sessionId) {
        var _a;
        if (!this.config) {
            this.q.push(this.setSessionId.bind(this, sessionId));
            return;
        }
        // Prevents starting a new session with the same session ID
        if (sessionId === this.config.sessionId) {
            return;
        }
        var previousSessionId = this.getSessionId();
        var lastEventTime = this.config.lastEventTime;
        var lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
        this.config.sessionId = sessionId;
        this.config.lastEventTime = undefined;
        this.config.pageCounter = 0;
        if (isSessionTrackingEnabled(this.config.defaultTracking)) {
            if (previousSessionId && lastEventTime) {
                this.track(DEFAULT_SESSION_END_EVENT, undefined, {
                    device_id: this.previousSessionDeviceId,
                    event_id: ++lastEventId,
                    session_id: previousSessionId,
                    time: lastEventTime + 1,
                    user_id: this.previousSessionUserId,
                });
            }
            this.config.lastEventTime = this.config.sessionId;
            this.track(DEFAULT_SESSION_START_EVENT, undefined, {
                event_id: ++lastEventId,
                session_id: this.config.sessionId,
                time: this.config.lastEventTime,
            });
        }
        this.previousSessionDeviceId = this.config.deviceId;
        this.previousSessionUserId = this.config.userId;
    };
    AmplitudeBrowser.prototype.extendSession = function () {
        if (!this.config) {
            this.q.push(this.extendSession.bind(this));
            return;
        }
        this.config.lastEventTime = Date.now();
    };
    AmplitudeBrowser.prototype.setTransport = function (transport) {
        if (!this.config) {
            this.q.push(this.setTransport.bind(this, transport));
            return;
        }
        this.config.transportProvider = createTransport(transport);
    };
    AmplitudeBrowser.prototype.identify = function (identify, eventOptions) {
        if (isInstanceProxy(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = convertProxyObjectToRealObject(new Identify(), queue);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.user_id) {
            this.setUserId(eventOptions.user_id);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.device_id) {
            this.setDeviceId(eventOptions.device_id);
        }
        return _super.prototype.identify.call(this, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.groupIdentify = function (groupType, groupName, identify, eventOptions) {
        if (isInstanceProxy(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = convertProxyObjectToRealObject(new Identify(), queue);
        }
        return _super.prototype.groupIdentify.call(this, groupType, groupName, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.revenue = function (revenue, eventOptions) {
        if (isInstanceProxy(revenue)) {
            var queue = revenue._q;
            revenue._q = [];
            revenue = convertProxyObjectToRealObject(new Revenue(), queue);
        }
        return _super.prototype.revenue.call(this, revenue, eventOptions);
    };
    AmplitudeBrowser.prototype.process = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var currentTime, isEventInNewSession;
            return __generator(this, function (_a) {
                currentTime = Date.now();
                isEventInNewSession = isNewSession(this.config.sessionTimeout, this.config.lastEventTime);
                if (event.event_type !== DEFAULT_SESSION_START_EVENT &&
                    event.event_type !== DEFAULT_SESSION_END_EVENT &&
                    (!event.session_id || event.session_id === this.getSessionId()) &&
                    isEventInNewSession) {
                    this.setSessionId(currentTime);
                }
                return [2 /*return*/, _super.prototype.process.call(this, event)];
            });
        });
    };
    return AmplitudeBrowser;
}(AmplitudeCore));

var createInstance = function () {
    var client = new AmplitudeBrowser();
    return {
        init: debugWrapper(client.init.bind(client), 'init', getClientLogConfig(client), getClientStates(client, ['config'])),
        add: debugWrapper(client.add.bind(client), 'add', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.plugins'])),
        remove: debugWrapper(client.remove.bind(client), 'remove', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.plugins'])),
        track: debugWrapper(client.track.bind(client), 'track', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.queue.length'])),
        logEvent: debugWrapper(client.logEvent.bind(client), 'logEvent', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.queue.length'])),
        identify: debugWrapper(client.identify.bind(client), 'identify', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.queue.length'])),
        groupIdentify: debugWrapper(client.groupIdentify.bind(client), 'groupIdentify', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.queue.length'])),
        setGroup: debugWrapper(client.setGroup.bind(client), 'setGroup', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.queue.length'])),
        revenue: debugWrapper(client.revenue.bind(client), 'revenue', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.queue.length'])),
        flush: debugWrapper(client.flush.bind(client), 'flush', getClientLogConfig(client), getClientStates(client, ['config.apiKey', 'timeline.queue.length'])),
        getUserId: debugWrapper(client.getUserId.bind(client), 'getUserId', getClientLogConfig(client), getClientStates(client, ['config', 'config.userId'])),
        setUserId: debugWrapper(client.setUserId.bind(client), 'setUserId', getClientLogConfig(client), getClientStates(client, ['config', 'config.userId'])),
        getDeviceId: debugWrapper(client.getDeviceId.bind(client), 'getDeviceId', getClientLogConfig(client), getClientStates(client, ['config', 'config.deviceId'])),
        setDeviceId: debugWrapper(client.setDeviceId.bind(client), 'setDeviceId', getClientLogConfig(client), getClientStates(client, ['config', 'config.deviceId'])),
        reset: debugWrapper(client.reset.bind(client), 'reset', getClientLogConfig(client), getClientStates(client, ['config', 'config.userId', 'config.deviceId'])),
        getSessionId: debugWrapper(client.getSessionId.bind(client), 'getSessionId', getClientLogConfig(client), getClientStates(client, ['config'])),
        setSessionId: debugWrapper(client.setSessionId.bind(client), 'setSessionId', getClientLogConfig(client), getClientStates(client, ['config'])),
        extendSession: debugWrapper(client.extendSession.bind(client), 'extendSession', getClientLogConfig(client), getClientStates(client, ['config'])),
        setOptOut: debugWrapper(client.setOptOut.bind(client), 'setOptOut', getClientLogConfig(client), getClientStates(client, ['config'])),
        setTransport: debugWrapper(client.setTransport.bind(client), 'setTransport', getClientLogConfig(client), getClientStates(client, ['config'])),
    };
};
var client = createInstance();

/* eslint-disable @typescript-eslint/unbound-method */
client.add; client.extendSession; client.flush; client.getDeviceId; var getSessionId = client.getSessionId; client.getUserId; client.groupIdentify; var identify$2 = client.identify, init = client.init, logEvent = client.logEvent; client.remove; client.reset; client.revenue; client.setDeviceId; client.setGroup; client.setOptOut; client.setSessionId; client.setTransport; var setUserId = client.setUserId; client.track;

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull frontend-user-journey'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 39
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/iwoca/Production/implementation/frontend-user-journey)
 */
const ApiKey = {
    development: 'f6201fdf6beace4ddaf040b33936a5e3',
    production: 'c8deac245de40e642fe0dbb2bbb0d2d2'
};
/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
const DefaultConfiguration = {
    plan: {
        version: '39',
        branch: 'main',
        source: 'frontend-user-journey',
        versionId: 'ade7731a-3750-474c-979a-025dbf18b519'
    },
    ...{
        ingestionMetadata: {
            sourceName: 'browser-typescript-ampli',
            sourceVersion: '2.0.0'
        }
    }
};
class ActivityTrackerSessionEnded {
    event_properties;
    event_type = '[Activity Tracker] - session ended';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ActivityTrackerSessionStarted {
    event_properties;
    event_type = '[Activity Tracker] - session started';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class BuyerClickedPayNowXSellBanner {
    event_type = '[Buyer] Clicked pay now x-sell banner';
}
class BuyerClickedXSellBanner {
    event_type = '[Buyer] Clicked x-sell banner';
}
class BuyerDisplayedPayNowXSellBanner {
    event_type = '[Buyer] Displayed pay now x-sell banner';
}
class BuyerDisplayedXSellBanner {
    event_type = '[Buyer] Displayed x-sell banner';
}
class BuyerSubmittedPayNowXSellApplication {
    event_properties;
    event_type = '[Buyer] Submitted pay now x-sell application';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class BuyerSubmittedXSellApplication {
    event_properties;
    event_type = '[Buyer] Submitted x-sell application';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class AdditionalGuarantorAdded {
    event_properties;
    event_type = 'Additional guarantor added';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class AdditionalGuarantorModalOpened {
    event_properties;
    event_type = 'Additional guarantor modal opened';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class AgedDebtorReportUploadClicked {
    event_type = 'Aged debtor report upload clicked';
}
class AgedDebtorReportUploaded {
    event_type = 'Aged debtor report uploaded';
}
class ApplicationPendingPageViewed {
    event_properties;
    event_type = 'Application pending page viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class BankDetailsSubmitted {
    event_type = 'Bank details submitted';
}
class BankStatementsUploaded {
    event_type = 'Bank statements uploaded';
}
class BusinessDetailsSubmitted {
    event_properties;
    event_type = 'Business details submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class BusinessPlanUploadClicked {
    event_type = 'Business plan upload clicked';
}
class BusinessPlanUploaded {
    event_type = 'Business plan uploaded';
}
class BusinessProfileSubmitted {
    event_type = 'Business profile submitted';
}
class BuyerDashboardViewed {
    event_properties;
    event_type = 'Buyer dashboard viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class CheckYourScheduleClicked {
    event_properties;
    event_type = 'Check your schedule clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ClickedAntBanner {
    event_properties;
    event_type = 'Clicked ANT banner';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ClickedButtonToPaySeller {
    event_type = 'Clicked button to pay seller';
}
class ClickedXSellBanner {
    event_properties;
    event_type = 'Clicked x-sell banner';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class CompanyAccountsUploadClicked {
    event_type = 'Company accounts upload clicked';
}
class CompanyAccountsUploaded {
    event_type = 'Company accounts uploaded';
}
class CompanyNameSearchSecondarySelected {
    event_type = 'Company name search secondary selected';
}
class CompanyNameSearched {
    event_type = 'Company name searched';
}
class CompanyTypeSelected {
    event_properties;
    event_type = 'Company type selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class CompletePaymentClicked {
    event_type = 'Complete payment clicked';
}
class CopyRequiredDocumentsClicked {
    event_properties;
    event_type = 'Copy required documents clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DashboardViewed {
    event_properties;
    event_type = 'Dashboard viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DecisionModalViewed {
    event_properties;
    event_type = 'Decision modal viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DirectorsProfileSubmitted {
    event_type = 'Directors profile submitted';
}
class DisplayedAntBanner {
    event_properties;
    event_type = 'Displayed ANT banner';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DisplayedXSellBanner {
    event_properties;
    event_type = 'Displayed x-sell banner';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DocUploadBannerLinkClicked {
    event_type = 'Doc upload banner - link clicked';
}
class DrawdownCompleteApplicationStepViewed {
    event_properties;
    event_type = 'Drawdown - complete application step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DrawdownCompleted {
    event_properties;
    event_type = 'Drawdown - completed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DrawdownConfirmClicked {
    event_properties;
    event_type = 'Drawdown - confirm clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DrawdownConfirmStepViewed {
    event_properties;
    event_type = 'Drawdown - confirm step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DrawdownMshFormOpened {
    event_type = 'Drawdown - MSH form opened';
}
class DrawdownMshModalOpened {
    event_type = 'Drawdown - MSH modal opened';
}
class DrawdownMshPersonAdded {
    event_type = 'Drawdown - MSH person added';
}
class DrawdownSignDocumentsStepViewed {
    event_properties;
    event_type = 'Drawdown - sign documents step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class DrawdownStarted {
    event_properties;
    event_type = 'Drawdown - started';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class EarlyRepaymentCalculatorLinkClicked {
    event_properties;
    event_type = 'Early Repayment Calculator Link clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class EarlyRepaymentCalculatorUsed {
    event_properties;
    event_type = 'Early Repayment Calculator Used';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class EditAmountOpened {
    event_properties;
    event_type = 'edit amount opened';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class EmailRequiredDocumentsClicked {
    event_properties;
    event_type = 'Email required documents clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ExitPollSelected {
    event_properties;
    event_type = 'Exit poll selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ExitSecurityChecksEarly {
    event_type = 'Exit security checks early';
}
class ExternalLinkClicked {
    event_properties;
    event_type = 'External link clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class FcaRegulatedClicked {
    event_properties;
    event_type = 'FCA regulated clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class FinishedSellerSignup {
    event_type = 'Finished seller signup';
}
class FormFieldCompleted {
    event_properties;
    event_type = 'Form field completed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class FormFieldStarted {
    event_properties;
    event_type = 'Form field started';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class FormalOfferSelected {
    event_properties;
    event_type = 'Formal offer selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class FormalisedAutoOfferGreaterThanTheRequestedAmount {
    event_properties;
    event_type = 'Formalised auto offer greater than the requested amount';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class HelpMethodSelected {
    event_properties;
    event_type = 'Help method selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class HelpOpened {
    event_properties;
    event_type = 'Help opened';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class HomescreenBannerClosed {
    event_type = 'Homescreen banner - closed';
}
class HomescreenBannerLinkClicked {
    event_properties;
    event_type = 'Homescreen banner - link clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class IndicativeOffersViewed {
    event_properties;
    event_type = 'Indicative Offers viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class InstantDecisionCtaClicked {
    event_properties;
    event_type = 'Instant decision CTA clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class InternalLinkClicked {
    event_properties;
    event_type = 'Internal link clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class LendingDecisionErrored {
    event_properties;
    event_type = 'Lending decision errored';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class LinkedRepaymentCard {
    event_type = 'Linked repayment card';
}
class LoginLinkRequested {
    event_type = 'Login link requested';
}
class LogoutClicked {
    event_properties;
    event_type = 'Logout clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ManagementAccountsUploadClicked {
    event_type = 'Management accounts upload clicked';
}
class ManagementAccountsUploaded {
    event_type = 'Management accounts uploaded';
}
class ManualCompanyNameCompleted {
    event_type = 'Manual company name completed';
}
class ManualCompanyNameSelected {
    event_properties;
    event_type = 'Manual company name selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class MobileLoanSummaryOpenend {
    event_type = 'Mobile loan summary openend';
}
class MyOffersVisited {
    event_properties;
    event_type = 'My offers visited';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class NewDocUploadsClickedEditAmount {
    event_type = 'New doc uploads - clicked edit amount';
}
class NewDocUploadsClickedLinkBankAccountSection {
    event_type = 'New doc uploads - clicked link bank account section';
}
class NewDocUploadsClickedManualBankStatementSection {
    event_type = 'New doc uploads - clicked manual bank statement section';
}
class NewDocUploadsClickedSubmitApplication {
    event_type = 'New doc uploads - clicked submit application';
}
class NewDocUploadsDocumentUploadFailed {
    event_properties;
    event_type = 'New doc uploads - document upload failed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class NewDocUploadsPageViewed {
    event_type = 'New doc uploads - page viewed';
}
class NewDocUploadsRequirementsOutstanding {
    event_type = 'New doc uploads - requirements outstanding';
}
class NewDocUploadsResolvedAllRequirements {
    event_type = 'New doc uploads - resolved all requirements';
}
class NewDocUploadsSuccessfullyLinkedBankAccountViaTruelayer {
    event_type = 'New doc uploads - successfully linked bank account via truelayer';
}
class NewDocUploadsSuccessfullyUploadedDocument {
    event_properties;
    event_type = 'New doc uploads - successfully uploaded document';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class NewLoanApplicationStepSubmitted {
    event_type = 'New loan - application step submitted';
}
class NewLoanApplicationStepViewed {
    event_type = 'New loan - application step viewed';
}
class NewLoanDocumentsStepSubmitted {
    event_properties;
    event_type = 'New loan - documents step submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class NewLoanDocumentsStepViewed {
    event_properties;
    event_type = 'New loan - documents step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class NewLoanRequestCompleted {
    event_properties;
    event_type = 'New loan - request completed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class NewLoanRequestStarted {
    event_properties;
    event_type = 'New loan - request started';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class OfferSelected {
    event_properties;
    event_type = 'Offer selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class OffersPageViewed {
    event_properties;
    event_type = 'Offers page viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class OpenBankingConnectStarted {
    event_properties;
    event_type = 'Open banking connect started';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class OpenBankingFinished {
    event_properties;
    event_type = 'Open banking finished';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class OpenBankingLinkedSuccessfully {
    event_type = 'Open banking linked successfully';
}
class OpenBankingLinkingCancelled {
    event_type = 'Open banking linking cancelled';
}
class OpenBankingLinkingFailed {
    event_type = 'Open banking linking failed';
}
class OpenBankingModalClosed {
    event_properties;
    event_type = 'Open banking modal closed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class OpenBankingModalOpened {
    event_properties;
    event_type = 'Open banking modal opened';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class PayLinkCopied {
    event_properties;
    event_type = 'Pay link copied';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class PayLinkLandingPageViewed {
    event_properties;
    event_type = 'Pay link landing page viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class PaymentOptionSelected {
    event_properties;
    event_type = 'Payment option selected';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class PaymentOptionSubmitted {
    event_properties;
    event_type = 'Payment option submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class PersonalDetailsSubmitted {
    event_properties;
    event_type = 'Personal details submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class PhoneNumberClicked {
    event_properties;
    event_type = 'Phone number clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ProductOffersLoadTime {
    event_properties;
    event_type = 'Product offers load time';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ProfileOpened {
    event_properties;
    event_type = 'Profile opened';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ProgressBarClicked {
    event_properties;
    event_type = 'Progress bar clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class RefreshSpendingLimitButtonClicked {
    event_type = 'Refresh spending limit button clicked';
}
class RepaymentCardLinked {
    event_type = 'repayment card linked';
}
class RepaymentScheduleViewed {
    event_properties;
    event_type = 'Repayment schedule viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class RequestMoreFundsClicked {
    event_properties;
    event_type = 'Request more funds clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class RequestedAmountChanged {
    event_properties;
    event_type = 'Requested amount changed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SaveApplicationClicked {
    event_properties;
    event_type = 'Save application clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SelectedCheckoutOption {
    event_properties;
    event_type = 'Selected checkout option';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SelectedOffer {
    event_properties;
    event_type = 'Selected offer';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SellerDocumentsUploaded {
    event_type = 'Seller documents uploaded';
}
class SellerEmailAdded {
    event_type = 'Seller email added';
}
class ShareRequiredDocumentsClosed {
    event_properties;
    event_type = 'Share required documents closed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class ShareRequiredDocumentsOpened {
    event_properties;
    event_type = 'Share required documents opened';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SignupCompleted {
    event_properties;
    event_type = 'Signup completed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SkippedToStandardDecision {
    event_type = 'Skipped to standard decision';
}
class SpendingLimitViewedOtherTerms {
    event_type = 'Spending limit viewed other terms';
}
class SpillBannerClosed {
    event_type = 'Spill banner - closed';
}
class SpillBannerLinkClicked {
    event_type = 'Spill banner - link clicked';
}
class StartedSecurityChecksEarly {
    event_type = 'Started security checks early';
}
class StepLoaded {
    event_properties;
    event_type = 'Step loaded';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SubmittedXSellApplication {
    event_properties;
    event_type = 'Submitted x-sell application';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SwitchedToCoreBusinessDashboard {
    event_properties;
    event_type = 'Switched to core business dashboard';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class SwitchedToIwocaPayDashboard {
    event_properties;
    event_type = 'Switched to iwocaPay dashboard';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupInlineFormApplicationStepSubmitted {
    event_properties;
    event_type = 'Topup - Inline form application step submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupInlineFormApplicationStepViewed {
    event_properties;
    event_type = 'Topup - Inline form application step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupInlineFormDocumentsStepSubmitted {
    event_properties;
    event_type = 'Topup - Inline form documents step submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupInlineFormDocumentsStepViewed {
    event_properties;
    event_type = 'Topup - Inline form documents step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupReapplyFormApplicationStepSubmitted {
    event_properties;
    event_type = 'Topup - Reapply form application step submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupReapplyFormApplicationStepViewed {
    event_properties;
    event_type = 'Topup - Reapply form application step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupReapplyFormDocumentsStepSubmitted {
    event_properties;
    event_type = 'Topup - Reapply form documents step submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupReapplyFormDocumentsStepViewed {
    event_properties;
    event_type = 'Topup - Reapply form documents step viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupRequestCompleted {
    event_properties;
    event_type = 'Topup - Request completed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TopupRequestStarted {
    event_properties;
    event_type = 'Topup request started';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TradingHistorySubmitted {
    event_properties;
    event_type = 'Trading history submitted';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TradingHistoryViewed {
    event_properties;
    event_type = 'Trading history viewed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TrueLayerBankConnectStarted {
    event_properties;
    event_type = 'TrueLayer bank connect started';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TrueLayerBankSelection {
    event_properties;
    event_type = 'TrueLayer bank selection';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class TrueLayerModalClosed {
    event_properties;
    event_type = 'TrueLayer modal closed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class UploadBankStatementsClicked {
    event_properties;
    event_type = 'Upload bank statements clicked';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class VatReturnsUploadClicked {
    event_type = 'VAT returns upload clicked';
}
class VatReturnsUploaded {
    event_type = 'VAT returns uploaded';
}
class ViewedOffers {
    event_properties;
    event_type = 'Viewed offers';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class XeroBankStatementsConnectStarted {
    event_type = 'Xero bank statements connect started';
}
class XeroBankStatementsLinkedSuccessfully {
    event_type = 'Xero bank statements linked successfully';
}
class XeroBankStatementsLinkingFailed {
    event_properties;
    event_type = 'Xero bank statements linking failed';
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_properties = event_properties;
    }
}
class XeroBankStatementsModalOpened {
    event_type = 'Xero bank statements modal opened';
}
const getVoidPromiseResult = () => ({ promise: Promise.resolve() });
// prettier-ignore
class Ampli {
    disabled = false;
    amplitude;
    get client() {
        this.isInitializedAndEnabled();
        return this.amplitude;
    }
    get isLoaded() {
        return this.amplitude != null;
    }
    isInitializedAndEnabled() {
        if (!this.amplitude) {
            console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
            return false;
        }
        return !this.disabled;
    }
    /**
     * Initialize the Ampli SDK. Call once when your application starts.
     *
     * @param options Configuration options to initialize the Ampli SDK with.
     */
    load(options) {
        this.disabled = options.disabled ?? false;
        if (this.amplitude) {
            console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
            return getVoidPromiseResult();
        }
        let apiKey = null;
        if (options.client && 'apiKey' in options.client) {
            apiKey = options.client.apiKey;
        }
        else if ('environment' in options) {
            apiKey = ApiKey[options.environment];
        }
        if (options.client && 'instance' in options.client) {
            this.amplitude = options.client.instance;
        }
        else if (apiKey) {
            this.amplitude = createInstance();
            const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
            return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
        }
        else {
            console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
        }
        return getVoidPromiseResult();
    }
    /**
     * Identify a user and set user properties.
     *
     * @param userId The user's id.
     * @param properties The user properties.
     * @param options Optional event options.
     */
    identify(userId, properties, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        if (userId) {
            options = { ...options, user_id: userId };
        }
        const amplitudeIdentify = new Identify();
        const eventProperties = properties;
        if (eventProperties != null) {
            for (const [key, value] of Object.entries(eventProperties)) {
                amplitudeIdentify.set(key, value);
            }
        }
        return this.amplitude.identify(amplitudeIdentify, options);
    }
    /**
     * Flush the event.
     */
    flush() {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.flush();
    }
    /**
     * Track event
     *
     * @param event The event to track.
     * @param options Optional event options.
     */
    track(event, options) {
        if (!this.isInitializedAndEnabled()) {
            return getVoidPromiseResult();
        }
        return this.amplitude.track(event, undefined, options);
    }
    /**
     * [Activity Tracker] - session ended
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BActivity%20Tracker%5D%20-%20session%20ended)
     *
     * This event tracks the end of a page session in Eden
     *
     * Owner: Adam Flynn
     *
     * @param properties The event's properties (e.g. page)
     * @param options Amplitude event options.
     */
    activityTrackerSessionEnded(properties, options) {
        return this.track(new ActivityTrackerSessionEnded(properties), options);
    }
    /**
     * [Activity Tracker] - session started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BActivity%20Tracker%5D%20-%20session%20started)
     *
     * This event tracks the start of the time spent on a given page in Eden.
     *
     * Owner: Adam Flynn
     *
     * @param properties The event's properties (e.g. page)
     * @param options Amplitude event options.
     */
    activityTrackerSessionStarted(properties, options) {
        return this.track(new ActivityTrackerSessionStarted(properties), options);
    }
    /**
     * [Buyer] Clicked pay now x-sell banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Clicked%20pay%20now%20x-sell%20banner)
     *
     * Clicked on the banner for cross-selling the core-business product from iwocaPay pay-now flow.
     *
     * @param options Amplitude event options.
     */
    buyerClickedPayNowXSellBanner(options) {
        return this.track(new BuyerClickedPayNowXSellBanner(), options);
    }
    /**
     * [Buyer] Clicked x-sell banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Clicked%20x-sell%20banner)
     *
     * Clicked on the banner for cross-selling the core-business product from iwocaPay.
     *
     * @param options Amplitude event options.
     */
    buyerClickedXSellBanner(options) {
        return this.track(new BuyerClickedXSellBanner(), options);
    }
    /**
     * [Buyer] Displayed pay now x-sell banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Displayed%20pay%20now%20x-sell%20banner)
     *
     * Showed banner for cross-selling the core-business product from iwocaPay pay-now flow.
     *
     * @param options Amplitude event options.
     */
    buyerDisplayedPayNowXSellBanner(options) {
        return this.track(new BuyerDisplayedPayNowXSellBanner(), options);
    }
    /**
     * [Buyer] Displayed x-sell banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Displayed%20x-sell%20banner)
     *
     * Showed banner for cross-selling the core-business product from iwocaPay.
     *
     * @param options Amplitude event options.
     */
    buyerDisplayedXSellBanner(options) {
        return this.track(new BuyerDisplayedXSellBanner(), options);
    }
    /**
     * [Buyer] Submitted pay now x-sell application
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Submitted%20pay%20now%20x-sell%20application)
     *
     * This event tracks when a buyer submits an application for cross-selling the core-business product from the iwocaPay pay-now flow.
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    buyerSubmittedPayNowXSellApplication(properties, options) {
        return this.track(new BuyerSubmittedPayNowXSellApplication(properties), options);
    }
    /**
     * [Buyer] Submitted x-sell application
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/%5BBuyer%5D%20Submitted%20x-sell%20application)
     *
     * This event tracks when a buyer submits an application for cross-selling the core-business product from iwocaPay.
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    buyerSubmittedXSellApplication(properties, options) {
        return this.track(new BuyerSubmittedXSellApplication(properties), options);
    }
    /**
     * Additional guarantor added
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Additional%20guarantor%20added)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. Active step)
     * @param options Amplitude event options.
     */
    additionalGuarantorAdded(properties, options) {
        return this.track(new AdditionalGuarantorAdded(properties), options);
    }
    /**
     * Additional guarantor modal opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Additional%20guarantor%20modal%20opened)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. Active step)
     * @param options Amplitude event options.
     */
    additionalGuarantorModalOpened(properties, options) {
        return this.track(new AdditionalGuarantorModalOpened(properties), options);
    }
    /**
     * Aged debtor report upload clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Aged%20debtor%20report%20upload%20clicked)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    agedDebtorReportUploadClicked(options) {
        return this.track(new AgedDebtorReportUploadClicked(), options);
    }
    /**
     * Aged debtor report uploaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Aged%20debtor%20report%20uploaded)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    agedDebtorReportUploaded(options) {
        return this.track(new AgedDebtorReportUploaded(), options);
    }
    /**
     * Application pending page viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Application%20pending%20page%20viewed)
     *
     * This event tracks when a user views the application pending page, which is displayed when their application is being processed and awaiting approval
     *
     * @param properties The event's properties (e.g. Aged debtor report required)
     * @param options Amplitude event options.
     */
    applicationPendingPageViewed(properties, options) {
        return this.track(new ApplicationPendingPageViewed(properties), options);
    }
    /**
     * Bank details submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Bank%20details%20submitted)
     *
     * Submitted bank details as part of the iwocaPay seller account activation.
     *
     * @param options Amplitude event options.
     */
    bankDetailsSubmitted(options) {
        return this.track(new BankDetailsSubmitted(), options);
    }
    /**
     * Bank statements uploaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Bank%20statements%20uploaded)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    bankStatementsUploaded(options) {
        return this.track(new BankStatementsUploaded(), options);
    }
    /**
     * Business details submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20details%20submitted)
     *
     * This event tracks when a user submits their business details during the sign-up process
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    businessDetailsSubmitted(properties, options) {
        return this.track(new BusinessDetailsSubmitted(properties), options);
    }
    /**
     * Business plan upload clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20plan%20upload%20clicked)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    businessPlanUploadClicked(options) {
        return this.track(new BusinessPlanUploadClicked(), options);
    }
    /**
     * Business plan uploaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20plan%20uploaded)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    businessPlanUploaded(options) {
        return this.track(new BusinessPlanUploaded(), options);
    }
    /**
     * Business profile submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Business%20profile%20submitted)
     *
     * Submitted business profile as part of the iwocaPay seller account activation.
     *
     * @param options Amplitude event options.
     */
    businessProfileSubmitted(options) {
        return this.track(new BusinessProfileSubmitted(), options);
    }
    /**
     * Buyer dashboard viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Buyer%20dashboard%20viewed)
     *
     * Tracks when a buyer sees their dashboard
     *
     * @param properties The event's properties (e.g. buyer_dashboard_state)
     * @param options Amplitude event options.
     */
    buyerDashboardViewed(properties, options) {
        return this.track(new BuyerDashboardViewed(properties), options);
    }
    /**
     * Check your schedule clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Check%20your%20schedule%20clicked)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. account_id)
     * @param options Amplitude event options.
     */
    checkYourScheduleClicked(properties, options) {
        return this.track(new CheckYourScheduleClicked(properties), options);
    }
    /**
     * Clicked ANT banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Clicked%20ANT%20banner)
     *
     * The seller clicked on the ANT-sell banner.
     *
     * @param properties The event's properties (e.g. url)
     * @param options Amplitude event options.
     */
    clickedAntBanner(properties, options) {
        return this.track(new ClickedAntBanner(properties), options);
    }
    /**
     * Clicked button to pay seller
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Clicked%20button%20to%20pay%20seller)
     *
     * This event tracks when a user clicks on the button to initiate a payment to a seller at the end of the iwocaPay drawdown.
     *
     * @param options Amplitude event options.
     */
    clickedButtonToPaySeller(options) {
        return this.track(new ClickedButtonToPaySeller(), options);
    }
    /**
     * Clicked x-sell banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Clicked%20x-sell%20banner)
     *
     * The seller clicked on the x-sell banner.
     *
     * @param properties The event's properties (e.g. url)
     * @param options Amplitude event options.
     */
    clickedXSellBanner(properties, options) {
        return this.track(new ClickedXSellBanner(properties), options);
    }
    /**
     * Company accounts upload clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20accounts%20upload%20clicked)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    companyAccountsUploadClicked(options) {
        return this.track(new CompanyAccountsUploadClicked(), options);
    }
    /**
     * Company accounts uploaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20accounts%20uploaded)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    companyAccountsUploaded(options) {
        return this.track(new CompanyAccountsUploaded(), options);
    }
    /**
     * Company name search secondary selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20name%20search%20secondary%20selected)
     *
     * This event tracks when a user selects the option to return to the auto company search while searching for a company name during the sign-up process
     *
     * @param options Amplitude event options.
     */
    companyNameSearchSecondarySelected(options) {
        return this.track(new CompanyNameSearchSecondarySelected(), options);
    }
    /**
     * Company name searched
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20name%20searched)
     *
     * This event tracks when a user the auto search to search for a specific company name during the sign-up process
     *
     * @param options Amplitude event options.
     */
    companyNameSearched(options) {
        return this.track(new CompanyNameSearched(), options);
    }
    /**
     * Company type selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Company%20type%20selected)
     *
     * This event tracks when a user selects their company type during the sign-up process
     *
     * @param properties The event's properties (e.g. company_type)
     * @param options Amplitude event options.
     */
    companyTypeSelected(properties, options) {
        return this.track(new CompanyTypeSelected(properties), options);
    }
    /**
     * Complete payment clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Complete%20payment%20clicked)
     *
     * Event Description: This event is triggered when a user clicks on the "Complete Payment" button which takes the buyer to the iwocaPay drawdown screens.
     *
     * @param options Amplitude event options.
     */
    completePaymentClicked(options) {
        return this.track(new CompletePaymentClicked(), options);
    }
    /**
     * Copy required documents clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Copy%20required%20documents%20clicked)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    copyRequiredDocumentsClicked(properties, options) {
        return this.track(new CopyRequiredDocumentsClicked(properties), options);
    }
    /**
     * Dashboard viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Dashboard%20viewed)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. account_id)
     * @param options Amplitude event options.
     */
    dashboardViewed(properties, options) {
        return this.track(new DashboardViewed(properties), options);
    }
    /**
     * Decision modal viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Decision%20modal%20viewed)
     *
     * The buyer has completed the signup and seen the decision modal.
     *
     * @param properties The event's properties (e.g. decision_modal_state)
     * @param options Amplitude event options.
     */
    decisionModalViewed(properties, options) {
        return this.track(new DecisionModalViewed(properties), options);
    }
    /**
     * Directors profile submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Directors%20profile%20submitted)
     *
     * Submitted directors profile as part of the iwocaPay seller account activation.
     *
     * @param options Amplitude event options.
     */
    directorsProfileSubmitted(options) {
        return this.track(new DirectorsProfileSubmitted(), options);
    }
    /**
     * Displayed ANT banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Displayed%20ANT%20banner)
     *
     * The ANT banner was presented to a seller
     *
     * @param properties The event's properties (e.g. url)
     * @param options Amplitude event options.
     */
    displayedAntBanner(properties, options) {
        return this.track(new DisplayedAntBanner(properties), options);
    }
    /**
     * Displayed x-sell banner
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Displayed%20x-sell%20banner)
     *
     * The x-sell banner was presented to a seller
     *
     * @param properties The event's properties (e.g. url)
     * @param options Amplitude event options.
     */
    displayedXSellBanner(properties, options) {
        return this.track(new DisplayedXSellBanner(properties), options);
    }
    /**
     * Doc upload banner - link clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Doc%20upload%20banner%20-%20link%20clicked)
     *
     * Event has no description in tracking plan.
     *
     * @param options Amplitude event options.
     */
    docUploadBannerLinkClicked(options) {
        return this.track(new DocUploadBannerLinkClicked(), options);
    }
    /**
     * Drawdown - complete application step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20complete%20application%20step%20viewed)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. amount)
     * @param options Amplitude event options.
     */
    drawdownCompleteApplicationStepViewed(properties, options) {
        return this.track(new DrawdownCompleteApplicationStepViewed(properties), options);
    }
    /**
     * Drawdown - completed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20completed)
     *
     * Customer has successfully drawn down.
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. amount)
     * @param options Amplitude event options.
     */
    drawdownCompleted(properties, options) {
        return this.track(new DrawdownCompleted(properties), options);
    }
    /**
     * Drawdown - confirm clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20confirm%20clicked)
     *
     * Customer has submitted the request to draw down.
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. amount)
     * @param options Amplitude event options.
     */
    drawdownConfirmClicked(properties, options) {
        return this.track(new DrawdownConfirmClicked(properties), options);
    }
    /**
     * Drawdown - confirm step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20confirm%20step%20viewed)
     *
     * Customer views the confirm step of the drawdown.
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. amount)
     * @param options Amplitude event options.
     */
    drawdownConfirmStepViewed(properties, options) {
        return this.track(new DrawdownConfirmStepViewed(properties), options);
    }
    /**
     * Drawdown - MSH form opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20MSH%20form%20opened)
     *
     * Customer clicked on the add person button to open the add person form
     *
     * Owner: Will F
     *
     * @param options Amplitude event options.
     */
    drawdownMshFormOpened(options) {
        return this.track(new DrawdownMshFormOpened(), options);
    }
    /**
     * Drawdown - MSH modal opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20MSH%20modal%20opened)
     *
     * Customers in the add_msh_drawdown_modal split test opened the modal to resolve the MSH funding requirement
     *
     * Owner: Will F
     *
     * @param options Amplitude event options.
     */
    drawdownMshModalOpened(options) {
        return this.track(new DrawdownMshModalOpened(), options);
    }
    /**
     * Drawdown - MSH person added
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20MSH%20person%20added)
     *
     * Customer saved their form entry in the add person form and the perosn was successfully saved to customer_state
     *
     * Owner: Will F
     *
     * @param options Amplitude event options.
     */
    drawdownMshPersonAdded(options) {
        return this.track(new DrawdownMshPersonAdded(), options);
    }
    /**
     * Drawdown - sign documents step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20sign%20documents%20step%20viewed)
     *
     * Customer views the sign documents step of the drawdown.
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. amount)
     * @param options Amplitude event options.
     */
    drawdownSignDocumentsStepViewed(properties, options) {
        return this.track(new DrawdownSignDocumentsStepViewed(properties), options);
    }
    /**
     * Drawdown - started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Drawdown%20-%20started)
     *
     * Customer starts the drawdown journey.
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. amount)
     * @param options Amplitude event options.
     */
    drawdownStarted(properties, options) {
        return this.track(new DrawdownStarted(properties), options);
    }
    /**
     * Early Repayment Calculator Link clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Early%20Repayment%20Calculator%20Link%20clicked)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. formal_offer_id)
     * @param options Amplitude event options.
     */
    earlyRepaymentCalculatorLinkClicked(properties, options) {
        return this.track(new EarlyRepaymentCalculatorLinkClicked(properties), options);
    }
    /**
     * Early Repayment Calculator Used
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Early%20Repayment%20Calculator%20Used)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. early_repayment_date)
     * @param options Amplitude event options.
     */
    earlyRepaymentCalculatorUsed(properties, options) {
        return this.track(new EarlyRepaymentCalculatorUsed(properties), options);
    }
    /**
     * edit amount opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/edit%20amount%20opened)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. amount)
     * @param options Amplitude event options.
     */
    editAmountOpened(properties, options) {
        return this.track(new EditAmountOpened(properties), options);
    }
    /**
     * Email required documents clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Email%20required%20documents%20clicked)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    emailRequiredDocumentsClicked(properties, options) {
        return this.track(new EmailRequiredDocumentsClicked(properties), options);
    }
    /**
     * Exit poll selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Exit%20poll%20selected)
     *
     * Event triggered when a user selects an advert in an exit poll during the sign-up process. (e.g. website banner ad, youtube, email..etc.)
     *
     * @param properties The event's properties (e.g. channelName)
     * @param options Amplitude event options.
     */
    exitPollSelected(properties, options) {
        return this.track(new ExitPollSelected(properties), options);
    }
    /**
     * Exit security checks early
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Exit%20security%20checks%20early)
     *
     * This event tracks when a user exits the security checks early during the spending limit process
     *
     * @param options Amplitude event options.
     */
    exitSecurityChecksEarly(options) {
        return this.track(new ExitSecurityChecksEarly(), options);
    }
    /**
     * External link clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/External%20link%20clicked)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    externalLinkClicked(properties, options) {
        return this.track(new ExternalLinkClicked(properties), options);
    }
    /**
     * FCA regulated clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/FCA%20regulated%20clicked)
     *
     * Owner: Jack Saunders
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    fcaRegulatedClicked(properties, options) {
        return this.track(new FcaRegulatedClicked(properties), options);
    }
    /**
     * Finished seller signup
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Finished%20seller%20signup)
     *
     * Finished iwocaPay seller account activation.
     *
     * @param options Amplitude event options.
     */
    finishedSellerSignup(options) {
        return this.track(new FinishedSellerSignup(), options);
    }
    /**
     * Form field completed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Form%20field%20completed)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. form_field)
     * @param options Amplitude event options.
     */
    formFieldCompleted(properties, options) {
        return this.track(new FormFieldCompleted(properties), options);
    }
    /**
     * Form field started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Form%20field%20started)
     *
     * This event tracks when a user begins filling out a form field
     *
     * @param properties The event's properties (e.g. form_field)
     * @param options Amplitude event options.
     */
    formFieldStarted(properties, options) {
        return this.track(new FormFieldStarted(properties), options);
    }
    /**
     * Formal offer selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Formal%20offer%20selected)
     *
     * This event tracks when a formal offer has been selected by a user on muli-offer views.
     *
     * @param properties The event's properties (e.g. formal_offer_id)
     * @param options Amplitude event options.
     */
    formalOfferSelected(properties, options) {
        return this.track(new FormalOfferSelected(properties), options);
    }
    /**
     * Formalised auto offer greater than the requested amount
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Formalised%20auto%20offer%20greater%20than%20the%20requested%20amount)
     *
     * The frontend formalises some auto offers if the auto offer amount is greater than the requested amount, and the auto product key is not the suggested product.
     *
     * See coda for detailed info
     *  https://coda.io/d/New-Applications-Team_dTHYDMUkpe0/Auto-formalisation-of-Auto-offers-in-the-manual-segment_suFdR?utm_source=slack#\_luY_C
     *
     * @param properties The event's properties (e.g. formalised_product_keys)
     * @param options Amplitude event options.
     */
    formalisedAutoOfferGreaterThanTheRequestedAmount(properties, options) {
        return this.track(new FormalisedAutoOfferGreaterThanTheRequestedAmount(properties), options);
    }
    /**
     * Help method selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Help%20method%20selected)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    helpMethodSelected(properties, options) {
        return this.track(new HelpMethodSelected(properties), options);
    }
    /**
     * Help opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Help%20opened)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    helpOpened(properties, options) {
        return this.track(new HelpOpened(properties), options);
    }
    /**
     * Homescreen banner - closed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Homescreen%20banner%20-%20closed)
     *
     * This event tracks when a user closes the homescreen banner
     *
     * @param options Amplitude event options.
     */
    homescreenBannerClosed(options) {
        return this.track(new HomescreenBannerClosed(), options);
    }
    /**
     * Homescreen banner - link clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Homescreen%20banner%20-%20link%20clicked)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. Link type)
     * @param options Amplitude event options.
     */
    homescreenBannerLinkClicked(properties, options) {
        return this.track(new HomescreenBannerLinkClicked(properties), options);
    }
    /**
     * Indicative Offers viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Indicative%20Offers%20viewed)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    indicativeOffersViewed(properties, options) {
        return this.track(new IndicativeOffersViewed(properties), options);
    }
    /**
     * Instant decision CTA clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Instant%20decision%20CTA%20clicked)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    instantDecisionCtaClicked(properties, options) {
        return this.track(new InstantDecisionCtaClicked(properties), options);
    }
    /**
     * Internal link clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Internal%20link%20clicked)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    internalLinkClicked(properties, options) {
        return this.track(new InternalLinkClicked(properties), options);
    }
    /**
     * Lending decision errored
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Lending%20decision%20errored)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    lendingDecisionErrored(properties, options) {
        return this.track(new LendingDecisionErrored(properties), options);
    }
    /**
     * Linked repayment card
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Linked%20repayment%20card)
     *
     * Tracks when a repayment card is linked to an iwocaPay account
     *
     * @param options Amplitude event options.
     */
    linkedRepaymentCard(options) {
        return this.track(new LinkedRepaymentCard(), options);
    }
    /**
     * Login link requested
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Login%20link%20requested)
     *
     * A login link was requested by a user on an iwocaPay landing page.
     *
     * @param options Amplitude event options.
     */
    loginLinkRequested(options) {
        return this.track(new LoginLinkRequested(), options);
    }
    /**
     * Logout clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Logout%20clicked)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    logoutClicked(properties, options) {
        return this.track(new LogoutClicked(properties), options);
    }
    /**
     * Management accounts upload clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Management%20accounts%20upload%20clicked)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    managementAccountsUploadClicked(options) {
        return this.track(new ManagementAccountsUploadClicked(), options);
    }
    /**
     * Management accounts uploaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Management%20accounts%20uploaded)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    managementAccountsUploaded(options) {
        return this.track(new ManagementAccountsUploaded(), options);
    }
    /**
     * Manual company name completed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Manual%20company%20name%20completed)
     *
     * This event tracks when a user manually enters their company name during the sign-up process
     *
     * @param options Amplitude event options.
     */
    manualCompanyNameCompleted(options) {
        return this.track(new ManualCompanyNameCompleted(), options);
    }
    /**
     * Manual company name selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Manual%20company%20name%20selected)
     *
     * This event tracks when a user manually selects the button to enter the company name manually in a sign up process
     *
     * @param properties The event's properties (e.g. location_clicked_from)
     * @param options Amplitude event options.
     */
    manualCompanyNameSelected(properties, options) {
        return this.track(new ManualCompanyNameSelected(properties), options);
    }
    /**
     * Mobile loan summary openend
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Mobile%20loan%20summary%20openend)
     *
     * Event has no description in tracking plan.
     *
     * @param options Amplitude event options.
     */
    mobileLoanSummaryOpenend(options) {
        return this.track(new MobileLoanSummaryOpenend(), options);
    }
    /**
     * My offers visited
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/My%20offers%20visited)
     *
     * Owner: Ariel Wolffe-Shah
     *
     * @param properties The event's properties (e.g. application_status)
     * @param options Amplitude event options.
     */
    myOffersVisited(properties, options) {
        return this.track(new MyOffersVisited(properties), options);
    }
    /**
     * New doc uploads - clicked edit amount
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20edit%20amount)
     *
     * This event tracks when a user clicks on the "edit amount" button in the new doc uploads page
     *
     * @param options Amplitude event options.
     */
    newDocUploadsClickedEditAmount(options) {
        return this.track(new NewDocUploadsClickedEditAmount(), options);
    }
    /**
     * New doc uploads - clicked link bank account section
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20link%20bank%20account%20section)
     *
     * This event tracks when a user clicks on the link bank account radio button
     *
     * @param options Amplitude event options.
     */
    newDocUploadsClickedLinkBankAccountSection(options) {
        return this.track(new NewDocUploadsClickedLinkBankAccountSection(), options);
    }
    /**
     * New doc uploads - clicked manual bank statement section
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20manual%20bank%20statement%20section)
     *
     * This event tracks when a user clicks on the manual bank statement radio button
     *
     * @param options Amplitude event options.
     */
    newDocUploadsClickedManualBankStatementSection(options) {
        return this.track(new NewDocUploadsClickedManualBankStatementSection(), options);
    }
    /**
     * New doc uploads - clicked submit application
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20clicked%20submit%20application)
     *
     * This event tracks when a user clicks the "submit application" button
     *
     * @param options Amplitude event options.
     */
    newDocUploadsClickedSubmitApplication(options) {
        return this.track(new NewDocUploadsClickedSubmitApplication(), options);
    }
    /**
     * New doc uploads - document upload failed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20document%20upload%20failed)
     *
     * This event tracks when a doc upload attempt failed
     *
     * @param properties The event's properties (e.g. Document name)
     * @param options Amplitude event options.
     */
    newDocUploadsDocumentUploadFailed(properties, options) {
        return this.track(new NewDocUploadsDocumentUploadFailed(properties), options);
    }
    /**
     * New doc uploads - page viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20page%20viewed)
     *
     * This event tracks when a user viewsnew doc uploads page
     *
     * @param options Amplitude event options.
     */
    newDocUploadsPageViewed(options) {
        return this.track(new NewDocUploadsPageViewed(), options);
    }
    /**
     * New doc uploads - requirements outstanding
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20requirements%20outstanding)
     *
     * This event tracks when an app is submitted but there are still outstanding requirements
     *
     * @param options Amplitude event options.
     */
    newDocUploadsRequirementsOutstanding(options) {
        return this.track(new NewDocUploadsRequirementsOutstanding(), options);
    }
    /**
     * New doc uploads - resolved all requirements
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20resolved%20all%20requirements)
     *
     * This event tracks when a user submits their app and has successfully resolved all the requirements
     *
     * @param options Amplitude event options.
     */
    newDocUploadsResolvedAllRequirements(options) {
        return this.track(new NewDocUploadsResolvedAllRequirements(), options);
    }
    /**
     * New doc uploads - successfully linked bank account via truelayer
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20successfully%20linked%20bank%20account%20via%20truelayer)
     *
     * This event tracks when a user successfully links their bank account via Truelayer
     *
     * @param options Amplitude event options.
     */
    newDocUploadsSuccessfullyLinkedBankAccountViaTruelayer(options) {
        return this.track(new NewDocUploadsSuccessfullyLinkedBankAccountViaTruelayer(), options);
    }
    /**
     * New doc uploads - successfully uploaded document
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20doc%20uploads%20-%20successfully%20uploaded%20document)
     *
     * Tracks successful upload of new document
     *
     * @param properties The event's properties (e.g. Document name)
     * @param options Amplitude event options.
     */
    newDocUploadsSuccessfullyUploadedDocument(properties, options) {
        return this.track(new NewDocUploadsSuccessfullyUploadedDocument(properties), options);
    }
    /**
     * New loan - application step submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20application%20step%20submitted)
     *
     * Event has no description in tracking plan.
     *
     * @param options Amplitude event options.
     */
    newLoanApplicationStepSubmitted(options) {
        return this.track(new NewLoanApplicationStepSubmitted(), options);
    }
    /**
     * New loan - application step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20application%20step%20viewed)
     *
     * Event has no description in tracking plan.
     *
     * @param options Amplitude event options.
     */
    newLoanApplicationStepViewed(options) {
        return this.track(new NewLoanApplicationStepViewed(), options);
    }
    /**
     * New loan - documents step submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20documents%20step%20submitted)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    newLoanDocumentsStepSubmitted(properties, options) {
        return this.track(new NewLoanDocumentsStepSubmitted(properties), options);
    }
    /**
     * New loan - documents step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20documents%20step%20viewed)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    newLoanDocumentsStepViewed(properties, options) {
        return this.track(new NewLoanDocumentsStepViewed(properties), options);
    }
    /**
     * New loan - request completed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20request%20completed)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    newLoanRequestCompleted(properties, options) {
        return this.track(new NewLoanRequestCompleted(properties), options);
    }
    /**
     * New loan - request started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/New%20loan%20-%20request%20started)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. account_id)
     * @param options Amplitude event options.
     */
    newLoanRequestStarted(properties, options) {
        return this.track(new NewLoanRequestStarted(properties), options);
    }
    /**
     * Offer selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Offer%20selected)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    offerSelected(properties, options) {
        return this.track(new OfferSelected(properties), options);
    }
    /**
     * Offers page viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Offers%20page%20viewed)
     *
     * A buyer was presented with multiple offers within the buyer signup.
     *
     * @param properties The event's properties (e.g. offer_ids)
     * @param options Amplitude event options.
     */
    offersPageViewed(properties, options) {
        return this.track(new OffersPageViewed(properties), options);
    }
    /**
     * Open banking connect started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20connect%20started)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    openBankingConnectStarted(properties, options) {
        return this.track(new OpenBankingConnectStarted(properties), options);
    }
    /**
     * Open banking finished
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20finished)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    openBankingFinished(properties, options) {
        return this.track(new OpenBankingFinished(properties), options);
    }
    /**
     * Open banking linked successfully
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20linked%20successfully)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    openBankingLinkedSuccessfully(options) {
        return this.track(new OpenBankingLinkedSuccessfully(), options);
    }
    /**
     * Open banking linking cancelled
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20linking%20cancelled)
     *
     * Owner: Jack Saunders
     *
     * @param options Amplitude event options.
     */
    openBankingLinkingCancelled(options) {
        return this.track(new OpenBankingLinkingCancelled(), options);
    }
    /**
     * Open banking linking failed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20linking%20failed)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    openBankingLinkingFailed(options) {
        return this.track(new OpenBankingLinkingFailed(), options);
    }
    /**
     * Open banking modal closed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20modal%20closed)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    openBankingModalClosed(properties, options) {
        return this.track(new OpenBankingModalClosed(properties), options);
    }
    /**
     * Open banking modal opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Open%20banking%20modal%20opened)
     *
     * Event for when the truelayer implementation had a mopdal that opened before you clicked through to their website, no longer in use on signup.
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    openBankingModalOpened(properties, options) {
        return this.track(new OpenBankingModalOpened(properties), options);
    }
    /**
     * Pay link copied
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Pay%20link%20copied)
     *
     * A pay link url was copied.
     *
     * @param properties The event's properties (e.g. url)
     * @param options Amplitude event options.
     */
    payLinkCopied(properties, options) {
        return this.track(new PayLinkCopied(properties), options);
    }
    /**
     * Pay link landing page viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Pay%20link%20landing%20page%20viewed)
     *
     * A user viewed the landing page for a pay link.
     *
     * @param properties The event's properties (e.g. pay_link_id)
     * @param options Amplitude event options.
     */
    payLinkLandingPageViewed(properties, options) {
        return this.track(new PayLinkLandingPageViewed(properties), options);
    }
    /**
     * Payment option selected
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Payment%20option%20selected)
     *
     * A buyer selected a payment option on a pay link landing page.
     *
     * @param properties The event's properties (e.g. pay_link_type)
     * @param options Amplitude event options.
     */
    paymentOptionSelected(properties, options) {
        return this.track(new PaymentOptionSelected(properties), options);
    }
    /**
     * Payment option submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Payment%20option%20submitted)
     *
     * A buyer submitted their selection of a payment option on a pay link landing page.
     *
     * @param properties The event's properties (e.g. pay_link_type)
     * @param options Amplitude event options.
     */
    paymentOptionSubmitted(properties, options) {
        return this.track(new PaymentOptionSubmitted(properties), options);
    }
    /**
     * Personal details submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Personal%20details%20submitted)
     *
     * Owner: Jack Saunders
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    personalDetailsSubmitted(properties, options) {
        return this.track(new PersonalDetailsSubmitted(properties), options);
    }
    /**
     * Phone number clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Phone%20number%20clicked)
     *
     * This event tracks when a user clicks on a phone number
     *
     * @param properties The event's properties (e.g. location_clicked_from)
     * @param options Amplitude event options.
     */
    phoneNumberClicked(properties, options) {
        return this.track(new PhoneNumberClicked(properties), options);
    }
    /**
     * Product offers load time
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Product%20offers%20load%20time)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. duration)
     * @param options Amplitude event options.
     */
    productOffersLoadTime(properties, options) {
        return this.track(new ProductOffersLoadTime(properties), options);
    }
    /**
     * Profile opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Profile%20opened)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    profileOpened(properties, options) {
        return this.track(new ProfileOpened(properties), options);
    }
    /**
     * Progress bar clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Progress%20bar%20clicked)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    progressBarClicked(properties, options) {
        return this.track(new ProgressBarClicked(properties), options);
    }
    /**
     * Refresh spending limit button clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Refresh%20spending%20limit%20button%20clicked)
     *
     * Triggered when the "Refresh spending limit" button is clicked by an iwocapay buyer
     *
     * @param options Amplitude event options.
     */
    refreshSpendingLimitButtonClicked(options) {
        return this.track(new RefreshSpendingLimitButtonClicked(), options);
    }
    /**
     * repayment card linked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/repayment%20card%20linked)
     *
     * Buyer linked repayment card in the iwocapay drawdown
     *
     * @param options Amplitude event options.
     */
    repaymentCardLinked(options) {
        return this.track(new RepaymentCardLinked(), options);
    }
    /**
     * Repayment schedule viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Repayment%20schedule%20viewed)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    repaymentScheduleViewed(properties, options) {
        return this.track(new RepaymentScheduleViewed(properties), options);
    }
    /**
     * Request more funds clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Request%20more%20funds%20clicked)
     *
     * Event has no description in tracking plan.
     *
     * @param properties The event's properties (e.g. account_id)
     * @param options Amplitude event options.
     */
    requestMoreFundsClicked(properties, options) {
        return this.track(new RequestMoreFundsClicked(properties), options);
    }
    /**
     * Requested amount changed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Requested%20amount%20changed)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    requestedAmountChanged(properties, options) {
        return this.track(new RequestedAmountChanged(properties), options);
    }
    /**
     * Save application clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Save%20application%20clicked)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    saveApplicationClicked(properties, options) {
        return this.track(new SaveApplicationClicked(properties), options);
    }
    /**
     * Selected checkout option
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Selected%20checkout%20option)
     *
     * This event tracks when a user selects a checkout option during the iwocaPay buyer journey
     *
     * @param properties The event's properties (e.g. pay_link_id)
     * @param options Amplitude event options.
     */
    selectedCheckoutOption(properties, options) {
        return this.track(new SelectedCheckoutOption(properties), options);
    }
    /**
     * Selected offer
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Selected%20offer)
     *
     * A buyer selected one out of multiple offers presented during the signup journey.
     *
     * @param properties The event's properties (e.g. offer_id)
     * @param options Amplitude event options.
     */
    selectedOffer(properties, options) {
        return this.track(new SelectedOffer(properties), options);
    }
    /**
     * Seller documents uploaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Seller%20documents%20uploaded)
     *
     * Uploaded seller documents as part of the iwocaPay seller account activation.
     *
     * @param options Amplitude event options.
     */
    sellerDocumentsUploaded(options) {
        return this.track(new SellerDocumentsUploaded(), options);
    }
    /**
     * Seller email added
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Seller%20email%20added)
     *
     * Seller added an email to their account as part of the iwocaPay seller account activation.
     *
     * @param options Amplitude event options.
     */
    sellerEmailAdded(options) {
        return this.track(new SellerEmailAdded(), options);
    }
    /**
     * Share required documents closed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Share%20required%20documents%20closed)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    shareRequiredDocumentsClosed(properties, options) {
        return this.track(new ShareRequiredDocumentsClosed(properties), options);
    }
    /**
     * Share required documents opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Share%20required%20documents%20opened)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    shareRequiredDocumentsOpened(properties, options) {
        return this.track(new ShareRequiredDocumentsOpened(properties), options);
    }
    /**
     * Signup completed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Signup%20completed)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    signupCompleted(properties, options) {
        return this.track(new SignupCompleted(properties), options);
    }
    /**
     * Skipped to standard decision
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Skipped%20to%20standard%20decision)
     *
     * This event tracks when a user skips to the standard decision step on the optional bank statements version of the trading history page.
     *
     * @param options Amplitude event options.
     */
    skippedToStandardDecision(options) {
        return this.track(new SkippedToStandardDecision(), options);
    }
    /**
     * Spending limit viewed other terms
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Spending%20limit%20viewed%20other%20terms)
     *
     * This event tracks when a user views other terms while viewing their spending limit
     *
     * @param options Amplitude event options.
     */
    spendingLimitViewedOtherTerms(options) {
        return this.track(new SpendingLimitViewedOtherTerms(), options);
    }
    /**
     * Spill banner - closed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Spill%20banner%20-%20closed)
     *
     * Event has no description in tracking plan.
     *
     * @param options Amplitude event options.
     */
    spillBannerClosed(options) {
        return this.track(new SpillBannerClosed(), options);
    }
    /**
     * Spill banner - link clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Spill%20banner%20-%20link%20clicked)
     *
     * Event has no description in tracking plan.
     *
     * @param options Amplitude event options.
     */
    spillBannerLinkClicked(options) {
        return this.track(new SpillBannerLinkClicked(), options);
    }
    /**
     * Started security checks early
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Started%20security%20checks%20early)
     *
     * User initiates the security checks ahead of time for spending limit in iwocaPay
     *
     * @param options Amplitude event options.
     */
    startedSecurityChecksEarly(options) {
        return this.track(new StartedSecurityChecksEarly(), options);
    }
    /**
     * Step loaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Step%20loaded)
     *
     * Owner: Emma Haines
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    stepLoaded(properties, options) {
        return this.track(new StepLoaded(properties), options);
    }
    /**
     * Submitted x-sell application
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Submitted%20x-sell%20application)
     *
     * A x-sell application was submitted by the seller after being presented with the x-sell banner.
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    submittedXSellApplication(properties, options) {
        return this.track(new SubmittedXSellApplication(properties), options);
    }
    /**
     * Switched to core business dashboard
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Switched%20to%20core%20business%20dashboard)
     *
     * User clicked a button on the iwocaPay dashboard to switch to the pandora dashboard.
     *
     * @param properties The event's properties (e.g. url)
     * @param options Amplitude event options.
     */
    switchedToCoreBusinessDashboard(properties, options) {
        return this.track(new SwitchedToCoreBusinessDashboard(properties), options);
    }
    /**
     * Switched to iwocaPay dashboard
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Switched%20to%20iwocaPay%20dashboard)
     *
     * User clicked a button on the pandora dashboard to switch to the iwocaPay dashboard.
     *
     * @param properties The event's properties (e.g. url)
     * @param options Amplitude event options.
     */
    switchedToIwocaPayDashboard(properties, options) {
        return this.track(new SwitchedToIwocaPayDashboard(properties), options);
    }
    /**
     * Topup - Inline form application step submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20application%20step%20submitted)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupInlineFormApplicationStepSubmitted(properties, options) {
        return this.track(new TopupInlineFormApplicationStepSubmitted(properties), options);
    }
    /**
     * Topup - Inline form application step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20application%20step%20viewed)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupInlineFormApplicationStepViewed(properties, options) {
        return this.track(new TopupInlineFormApplicationStepViewed(properties), options);
    }
    /**
     * Topup - Inline form documents step submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20documents%20step%20submitted)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupInlineFormDocumentsStepSubmitted(properties, options) {
        return this.track(new TopupInlineFormDocumentsStepSubmitted(properties), options);
    }
    /**
     * Topup - Inline form documents step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Inline%20form%20documents%20step%20viewed)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupInlineFormDocumentsStepViewed(properties, options) {
        return this.track(new TopupInlineFormDocumentsStepViewed(properties), options);
    }
    /**
     * Topup - Reapply form application step submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20application%20step%20submitted)
     *
     * Owner: Freddie Wellfair
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupReapplyFormApplicationStepSubmitted(properties, options) {
        return this.track(new TopupReapplyFormApplicationStepSubmitted(properties), options);
    }
    /**
     * Topup - Reapply form application step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20application%20step%20viewed)
     *
     * Owner: Freddie Wellfair
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupReapplyFormApplicationStepViewed(properties, options) {
        return this.track(new TopupReapplyFormApplicationStepViewed(properties), options);
    }
    /**
     * Topup - Reapply form documents step submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20documents%20step%20submitted)
     *
     * Owner: Freddie Wellfair
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupReapplyFormDocumentsStepSubmitted(properties, options) {
        return this.track(new TopupReapplyFormDocumentsStepSubmitted(properties), options);
    }
    /**
     * Topup - Reapply form documents step viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Reapply%20form%20documents%20step%20viewed)
     *
     * Owner: Freddie Wellfair
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupReapplyFormDocumentsStepViewed(properties, options) {
        return this.track(new TopupReapplyFormDocumentsStepViewed(properties), options);
    }
    /**
     * Topup - Request completed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20-%20Request%20completed)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. application_id)
     * @param options Amplitude event options.
     */
    topupRequestCompleted(properties, options) {
        return this.track(new TopupRequestCompleted(properties), options);
    }
    /**
     * Topup request started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Topup%20request%20started)
     *
     * Owner: Connor Meredith
     *
     * @param properties The event's properties (e.g. account_id)
     * @param options Amplitude event options.
     */
    topupRequestStarted(properties, options) {
        return this.track(new TopupRequestStarted(properties), options);
    }
    /**
     * Trading history submitted
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Trading%20history%20submitted)
     *
     * Owner: Jack Saunders
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    tradingHistorySubmitted(properties, options) {
        return this.track(new TradingHistorySubmitted(properties), options);
    }
    /**
     * Trading history viewed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Trading%20history%20viewed)
     *
     * The trading history page is opened and all the requirements have loaded
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param properties The event's properties (e.g. Aged debtor report required)
     * @param options Amplitude event options.
     */
    tradingHistoryViewed(properties, options) {
        return this.track(new TradingHistoryViewed(properties), options);
    }
    /**
     * TrueLayer bank connect started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/TrueLayer%20bank%20connect%20started)
     *
     * This event tracks when a user starts the process of connecting their bank account with TrueLayer during the sign-up process
     *
     * @param properties The event's properties (e.g. bankId)
     * @param options Amplitude event options.
     */
    trueLayerBankConnectStarted(properties, options) {
        return this.track(new TrueLayerBankConnectStarted(properties), options);
    }
    /**
     * TrueLayer bank selection
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/TrueLayer%20bank%20selection)
     *
     * This event tracks when a user selects a bank during the sign-up process on TrueLayer
     *
     * @param properties The event's properties (e.g. bankId)
     * @param options Amplitude event options.
     */
    trueLayerBankSelection(properties, options) {
        return this.track(new TrueLayerBankSelection(properties), options);
    }
    /**
     * TrueLayer modal closed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/TrueLayer%20modal%20closed)
     *
     * This event tracks when a user closes the TrueLayer consent flow modal during the sign-up Trading History process
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    trueLayerModalClosed(properties, options) {
        return this.track(new TrueLayerModalClosed(properties), options);
    }
    /**
     * Upload bank statements clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Upload%20bank%20statements%20clicked)
     *
     * Owner: r.maimon@iwoca.co.uk
     *
     * @param properties The event's properties (e.g. category)
     * @param options Amplitude event options.
     */
    uploadBankStatementsClicked(properties, options) {
        return this.track(new UploadBankStatementsClicked(properties), options);
    }
    /**
     * VAT returns upload clicked
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/VAT%20returns%20upload%20clicked)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    vatReturnsUploadClicked(options) {
        return this.track(new VatReturnsUploadClicked(), options);
    }
    /**
     * VAT returns uploaded
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/VAT%20returns%20uploaded)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    vatReturnsUploaded(options) {
        return this.track(new VatReturnsUploaded(), options);
    }
    /**
     * Viewed offers
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Viewed%20offers)
     *
     * This event tracks when a user views offers within the iwocaPay buyer journey
     *
     * @param properties The event's properties (e.g. choose_offer_page)
     * @param options Amplitude event options.
     */
    viewedOffers(properties, options) {
        return this.track(new ViewedOffers(properties), options);
    }
    /**
     * Xero bank statements connect started
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20connect%20started)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    xeroBankStatementsConnectStarted(options) {
        return this.track(new XeroBankStatementsConnectStarted(), options);
    }
    /**
     * Xero bank statements linked successfully
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20linked%20successfully)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    xeroBankStatementsLinkedSuccessfully(options) {
        return this.track(new XeroBankStatementsLinkedSuccessfully(), options);
    }
    /**
     * Xero bank statements linking failed
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20linking%20failed)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param properties The event's properties (e.g. Error message)
     * @param options Amplitude event options.
     */
    xeroBankStatementsLinkingFailed(properties, options) {
        return this.track(new XeroBankStatementsLinkingFailed(properties), options);
    }
    /**
     * Xero bank statements modal opened
     *
     * [View in Tracking Plan](https://data.amplitude.com/iwoca/Production/events/main/latest/Xero%20bank%20statements%20modal%20opened)
     *
     * Owner: Laurence Bernstein-Newman
     *
     * @param options Amplitude event options.
     */
    xeroBankStatementsModalOpened(options) {
        return this.track(new XeroBankStatementsModalOpened(), options);
    }
}

class AmplitudeGTMPlugin {
    name = 'AmplitudeGTMPlugin';
    type = 'destination';
    // eslint-disable-next-line require-await
    async setup() {
        window.dataLayer = window.dataLayer || [];
    }
    // eslint-disable-next-line require-await
    async execute(event) {
        if (event.event_type === '$identify') {
            window.dataLayer.push({
                event: 'addedStateKeyToUser',
                state_key: event.user_id,
            });
        }
        else {
            window.dataLayer.push({
                event: 'amplitude_event',
                event_type: event.event_type,
                event_properties: event.event_properties,
            });
        }
        return {
            code: 200,
            event: event,
            message: 'Event pushed onto GTM Data Layer',
        };
    }
}

let ampli = new Ampli();
/**
 * Initialises the tracking configuration.
 */
function initialise({ environment, disabled, clientConfiguration, }) {
    const configuration = clientConfiguration || {
        defaultTracking: {
            pageViews: {
                trackHistoryChanges: 'all',
            },
        },
    };
    ampli.load({
        environment,
        disabled,
        client: { configuration },
    });
    ampli.client.add(new AmplitudeGTMPlugin());
}
/**
 * Identifies the customer using their state key.
 */
function identifyCustomer({ stateKey, country, isImpersonating, ...otherProperties }) {
    ampli.identify(stateKey, {
        ...otherProperties,
        impersonating: isImpersonating,
        site: country,
        user_type: 'customer',
    });
}
/**
 * Identifies the introducer using their introducer id.
 */
function identifyIntroducer({ introducerId, country, isImpersonating, ...otherProperties }) {
    ampli.identify(introducerId, {
        ...otherProperties,
        impersonating: isImpersonating,
        site: country,
        user_type: 'introducer',
    });
}
function identifyStaff({ staffId, country, ...otherProperties }) {
    ampli.identify(staffId, {
        ...otherProperties,
        site: country,
        user_type: 'staff',
    });
}
/**
 * Resets the tracking configuration.
 * For testing purposes only.
 */
function reset() {
    ampli = new Ampli();
}
var tracking = {
    initialise,
    identifyCustomer,
    identifyIntroducer,
    identifyStaff,
    ampli,
    reset,
};

const EVENT_NAMES$3 = {
    INTRODUCER_SIGNUP_STARTED: 'Introducer sign up started',
    INTRODUCER_SIGNUP_COMPLETED: 'Introducer sign up completed',
    APPLICATION_MODAL_OPENED: 'Application modal opened',
    APPLICATION_STARTED: 'Application started',
    OFFER_ACCEPTED: 'Offer accepted',
    DOCUMENT_UPLOAD_STARTED: 'Documents upload started',
    NOTIFICATION_SHOWN: 'Notification shown',
    NOTIFICATION_CTA_CLICKED: 'Notification CTA clicked',
    PAGE_VISITED: 'Introducer Portal Visited',
};
const CATEGORY$4 = {
    INTRODUCER_SIGNUP: 'Introducer signup',
    INTRODUCER_SIGNUP_DE: 'Introducer signup DE',
    INTRODUCER_PORTAL: 'Introducer portal',
    INTRODUCER_PORTAL_DE: 'Introducer portal DE',
};
const SUB_CATEGORY = {
    INTRODUCER_SIGNUP: 'Introducer sign up',
    INTRODUCER_SIGNUP_COMPLETE: 'Introducer sign up complete',
    APPLICATION_MODAL: 'Application modal',
    MAIN_PORTAL: 'Main portal',
};
/**
 * @deprecated
 */
const TRACK_INTRODUCER_SIGNUP_STARTED = {
    event: EVENT_NAMES$3.INTRODUCER_SIGNUP_STARTED,
    category: CATEGORY$4.INTRODUCER_SIGNUP,
    subCategory: SUB_CATEGORY.INTRODUCER_SIGNUP,
};
/**
 * @deprecated
 */
function getIntroducerSignupStartedEventDetails({ signupType, source, locale, }) {
    return {
        event: EVENT_NAMES$3.INTRODUCER_SIGNUP_STARTED,
        category: getIntroducerPortalSignupCategoryfromLocale(locale),
        payload: {
            signupType,
            source: source,
        },
    };
}
/**
 * @deprecated
 */
function getIntroducerSignupCompleteEventDetails({ introducerType, source, locale, }) {
    return {
        event: EVENT_NAMES$3.INTRODUCER_SIGNUP_COMPLETED,
        category: getIntroducerPortalSignupCategoryfromLocale(locale),
        payload: {
            introducerType: introducerType,
            source: source,
        },
    };
}
/**
 * @deprecated
 */
function getStepZeroModalOpenedEventDetails({ source, locale, }) {
    return {
        event: EVENT_NAMES$3.APPLICATION_MODAL_OPENED,
        category: getIntroducerPortalCategoryfromLocale(locale),
        payload: {
            source: source,
        },
    };
}
/**
 * @deprecated
 */
function getApplicationStartedEventDetails({ source, productType, requestedAmount, locale, }) {
    return {
        event: EVENT_NAMES$3.APPLICATION_STARTED,
        category: getIntroducerPortalCategoryfromLocale(locale),
        payload: {
            source: source,
            productType: productType,
            requestedAmount: requestedAmount,
        },
    };
}
/**
 * @deprecated
 */
function getOfferAcceptedeventDetails({ source, locale, productType, offeredAmount, }) {
    return {
        event: EVENT_NAMES$3.APPLICATION_STARTED,
        category: getIntroducerPortalCategoryfromLocale(locale),
        payload: {
            source: source,
            productType: productType,
            offeredAmount: offeredAmount,
        },
    };
}
/**
 * @deprecated
 */
function getDocumentUploadStartedEventDetails({ documentCategory, locale, }) {
    return {
        event: EVENT_NAMES$3.DOCUMENT_UPLOAD_STARTED,
        category: getIntroducerPortalCategoryfromLocale(locale),
        payload: {
            documentCategory: documentCategory,
        },
    };
}
/**
 * @deprecated
 */
function getNotificationShownEventDetails({ locale, }) {
    return {
        event: EVENT_NAMES$3.NOTIFICATION_SHOWN,
        category: getIntroducerPortalCategoryfromLocale(locale),
    };
}
/**
 * @deprecated
 */
function getNotificationCTAClickedDetails({ CTAClicked, CTALocation, CTAText, locale, }) {
    return {
        event: EVENT_NAMES$3.NOTIFICATION_CTA_CLICKED,
        category: getIntroducerPortalCategoryfromLocale(locale),
        payload: {
            CTAClicked,
            CTAText,
            CTALocation,
        },
    };
}
/**
 * @deprecated
 */
function introducerPortalEventCreator({ event, locale, payload, }) {
    return {
        event: event,
        category: getIntroducerPortalCategoryfromLocale(locale),
        payload: {
            ...(payload || {}),
        },
    };
}
function getIntroducerPortalCategoryfromLocale(locale) {
    if (locale === 'de')
        return CATEGORY$4.INTRODUCER_PORTAL_DE;
    return CATEGORY$4.INTRODUCER_PORTAL;
}
function getIntroducerPortalSignupCategoryfromLocale(locale) {
    if (locale === 'de')
        return CATEGORY$4.INTRODUCER_SIGNUP_DE;
    return CATEGORY$4.INTRODUCER_SIGNUP;
}
/**
 * @deprecated
 */
function getPageVisitedEvent$3() {
    return {
        category: CATEGORY$4.INTRODUCER_PORTAL,
        event: EVENT_NAMES$3.PAGE_VISITED,
    };
}

var introducerPortal = /*#__PURE__*/Object.freeze({
    __proto__: null,
    TRACK_INTRODUCER_SIGNUP_STARTED: TRACK_INTRODUCER_SIGNUP_STARTED,
    getApplicationStartedEventDetails: getApplicationStartedEventDetails,
    getDocumentUploadStartedEventDetails: getDocumentUploadStartedEventDetails,
    getIntroducerSignupCompleteEventDetails: getIntroducerSignupCompleteEventDetails,
    getIntroducerSignupStartedEventDetails: getIntroducerSignupStartedEventDetails,
    getNotificationCTAClickedDetails: getNotificationCTAClickedDetails,
    getNotificationShownEventDetails: getNotificationShownEventDetails,
    getOfferAcceptedeventDetails: getOfferAcceptedeventDetails,
    getPageVisitedEvent: getPageVisitedEvent$3,
    getStepZeroModalOpenedEventDetails: getStepZeroModalOpenedEventDetails,
    introducerPortalEventCreator: introducerPortalEventCreator
});

/**
 * @deprecated
 */
const EVENT_NAMES$2 = {
    AMOUNT_CONFIRMED: 'Amount Confirmed',
    FUNDS_WITHDRAWN: 'Funds Withdrawn',
    PAGE_VISITED: 'Account Pages Visited',
};
/**
 * @deprecated
 */
const CATEGORY$3 = {
    ACCOUNT_PAGES: 'Account pages',
    ACCOUNT_PAGES_DE: 'Account pages DE',
};
/**
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getCompleteDrawdownEventProperties(properties) {
    return {
        event: EVENT_NAMES$2.FUNDS_WITHDRAWN,
        category: CATEGORY$3.ACCOUNT_PAGES,
        payload: {
            requestedAmount: properties.requestedAmount,
            offeredAmount: properties.offeredAmount,
            withDrawnAmount: properties.withDrawnAmount,
            percentageOfOfferedAmountWithdrawn: properties.percentageOfOfferedAmountWithdrawn,
            differenceBetweenDrawDownAmountAndMaxAmount: properties.differenceBetweenDrawDownAmountAndMaxAmount,
            requestedProductType: properties.requestedProductType,
            suggestedProductType: properties.suggestedProductType,
            suggestedProductKey: properties.suggestedProductKey,
            offeredProductType: properties.offeredProductType,
        },
    };
}
/**
 * @deprecated
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getBeginDrawdownEventProperties(properties) {
    return {
        event: EVENT_NAMES$2.AMOUNT_CONFIRMED,
        category: CATEGORY$3.ACCOUNT_PAGES,
        payload: {
            offeredAmount: properties.offeredAmount,
            withDrawnAmount: properties.withDrawnAmount,
            offeredProductType: properties.offeredProductType,
        },
    };
}
/**
 * @deprecated
 */
const pandoraEventCreator = ({ event, category, payload, }) => {
    return {
        event: event,
        category: category,
        payload: {
            ...(payload || {}),
        },
    };
};
// TODO: remove below redundant event
/**
 * @deprecated
 */
function getPageVisitedEvent$2() {
    return {
        category: CATEGORY$3.ACCOUNT_PAGES,
        event: EVENT_NAMES$2.PAGE_VISITED,
    };
}

var pandora = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CATEGORY: CATEGORY$3,
    EVENT_NAMES: EVENT_NAMES$2,
    getBeginDrawdownEventProperties: getBeginDrawdownEventProperties,
    getCompleteDrawdownEventProperties: getCompleteDrawdownEventProperties,
    getPageVisitedEvent: getPageVisitedEvent$2,
    pandoraEventCreator: pandoraEventCreator
});

function getDomainCountry() {
    if (typeof window === 'undefined') {
        console.error('Window is not defined');
        return '';
    }
    const host = window.location.host;
    if (host.includes('de')) {
        return 'DE';
    }
    if (host.includes('co.uk')) {
        return 'UK';
    }
    return `Other - ${host}`;
}

const CATEGORY$2 = {
    PARTNER_DEVELOPER_PORTAL: 'Partner developer portal',
    PARTNER_DEVELOPER_PORTAL_DE: 'Partner developer portal DE',
};
/**
 * @deprecated
 */
function partnerDeveloperPortalEventCreator({ event, payload, }) {
    return {
        event: event,
        category: getPartnerDeveloperPortalCategoryfromLocale(),
        payload: {
            ...(payload || {}),
        },
    };
}
function getPartnerDeveloperPortalCategoryfromLocale() {
    if (getDomainCountry() === 'DE')
        return CATEGORY$2.PARTNER_DEVELOPER_PORTAL_DE;
    return CATEGORY$2.PARTNER_DEVELOPER_PORTAL;
}

var partnerDeveloperPortal = /*#__PURE__*/Object.freeze({
    __proto__: null,
    partnerDeveloperPortalEventCreator: partnerDeveloperPortalEventCreator
});

/**
 * @deprecated
 */
const Events = { introducerPortal, pandora, partnerDeveloperPortal };

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$3 = Array.isArray;

var isArray_1 = isArray$3;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$3 = freeGlobal || freeSelf || Function('return this')();

var _root = root$3;

var root$2 = _root;

/** Built-in value references. */
var Symbol$4 = root$2.Symbol;

var _Symbol = Symbol$4;

var Symbol$3 = _Symbol;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$5.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$4.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$2 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$2(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$2;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$1;

var baseGetTag$1 = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$3(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag$1(value) == symbolTag);
}

var isSymbol_1 = isSymbol$3;

var isArray$2 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray$2(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$1;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$3;

var baseGetTag = _baseGetTag,
    isObject$2 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$2(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$1;

var root$1 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$1['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$1;

var isFunction = isFunction_1,
    isMasked = _isMasked,
    isObject$1 = isObject_1,
    toSource = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$3 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$3(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$3;

var getNative$2 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$2(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$1.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$2(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$2;

var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$1.prototype.clear = listCacheClear;
ListCache$1.prototype['delete'] = listCacheDelete;
ListCache$1.prototype.get = listCacheGet;
ListCache$1.prototype.has = listCacheHas;
ListCache$1.prototype.set = listCacheSet;

var _ListCache = ListCache$1;

var getNative$1 = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var Map$2 = getNative$1(root, 'Map');

var _Map = Map$2;

var Hash = _Hash,
    ListCache = _ListCache,
    Map$1 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = mapCacheClear;
MapCache$1.prototype['delete'] = mapCacheDelete;
MapCache$1.prototype.get = mapCacheGet;
MapCache$1.prototype.has = mapCacheHas;
MapCache$1.prototype.set = mapCacheSet;

var _MapCache = MapCache$1;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$1;

var Symbol$1 = _Symbol,
    arrayMap = _arrayMap,
    isArray$1 = isArray_1,
    isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$1;

var isArray = isArray_1,
    isKey = _isKey,
    stringToPath = _stringToPath,
    toString = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

var _castPath = castPath$2;

var isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$2(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey$2;

var castPath$1 = _castPath,
    toKey$1 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = castPath$1(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$1(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$1;

var baseGet = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

var lodashGet = /*@__PURE__*/getDefaultExportFromCjs(get_1);

var getNative = _getNative;

var defineProperty$1 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$1;

var defineProperty = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$1;

var baseAssignValue = _baseAssignValue,
    eq = eq_1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$1(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue$1;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$1;

var assignValue = _assignValue,
    castPath = _castPath,
    isIndex = _isIndex,
    isObject = isObject_1,
    toKey = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$1;

var baseSet = _baseSet;

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

var set_1 = set;

var lodashSet = /*@__PURE__*/getDefaultExportFromCjs(set_1);

/**
 * @deprecated
 */
const CUSTOMERJOURNEY_STORAGE_KEY = '_CUSTOMERJOURNEY';
/**
 * @deprecated
 */
const initialize$1 = ({ customerJourney, trackWithDataAttribute = false, } = {}) => {
    if (!customerJourney)
        return console.error('[TRACKING] No customer journey provided to initialization call');
    if (typeof window !== 'undefined') {
        lodashSet(window, CUSTOMERJOURNEY_STORAGE_KEY, customerJourney);
        if (trackWithDataAttribute) {
            window.addEventListener('click', (e) => {
                const target = e.target;
                const trackingId = target.getAttribute('data-tracking-id');
                if (trackingId === null)
                    return;
                trackClick({ identifier: trackingId });
            });
        }
    }
};
/**
 * @deprecated
 */
const identifyUser = (statekey, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
{ isIntroducer = false } = {}) => {
    identify$1(statekey);
};
/**
 * @deprecated
 */
const trackClick = ({ customerJourney, identifier, deviceType, }) => {
    const category = getGlobalCustomerJourney(customerJourney);
    const event = 'Click';
    const label = Boolean(deviceType)
        ? `${identifier} [${deviceType}]`
        : identifier;
    trackEvent({ category, event, label });
};
const formInteractions = ['View', 'Submit', 'Error'];
/**
 * @deprecated
 */
const trackForm = ({ customerJourney, interaction, formName: label, additionalValue: value, }) => {
    if (!formInteractions.includes(interaction))
        return;
    const event = `${interaction} Form`;
    const category = getGlobalCustomerJourney(customerJourney);
    trackEvent({ category, event, label, value });
};
const formFieldInteractions = ['Change', 'Error'];
/**
 * @deprecated
 */
const trackFormField = ({ customerJourney, formName, fieldName, fieldValue, interaction, }) => {
    if (typeof fieldName !== 'string' || fieldName === 'false')
        return;
    if (!formFieldInteractions.includes(interaction))
        return;
    const category = getGlobalCustomerJourney(customerJourney);
    const event = `Form-field ${interaction}`;
    let label = `${formName} - ${fieldName}`;
    if (fieldValue !== undefined) {
        label += ` - ${fieldValue}`;
    }
    trackEvent({ category, event, label });
};
/**
 * @deprecated
 */
const trackSlider = ({ customerJourney, sliderName, sliderValue: value, }) => {
    const category = getGlobalCustomerJourney(customerJourney);
    const event = 'Slider change';
    const label = `${sliderName} Slider`;
    trackEvent({ category, event, label, value });
};
/**
 * @deprecated
 */
const trackError = ({ customerJourney, identifier: label, }) => {
    const category = getGlobalCustomerJourney(customerJourney);
    const event = 'Show Error';
    trackEvent({ category, event, label });
};
const modalInteractions = ['Open', 'Close'];
/**
 * @deprecated
 */
const trackModal = ({ customerJourney, interaction, modalName: label, }) => {
    if (!modalInteractions.includes(interaction))
        return;
    const event = `${interaction} Modal`;
    const category = getGlobalCustomerJourney(customerJourney);
    trackEvent({ category, event, label });
};
/**
 * @deprecated
 */
const trackEvent = ({ category: customerJourney, event, label, value, }) => {
    const category = getGlobalCustomerJourney(customerJourney);
    // Tag manager relies on this being prefixed with [SEGMENT]
    // So it can filter for it and pass it to GA
    const GTMEventName = `[SEGMENT] ${event}`;
    track$1(GTMEventName, { category, label, value });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function pushToDataLayer(args) {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(args);
    }
}
/**
 * @deprecated
 */
function identify$1(stateKey) {
    pushToDataLayer({
        event: 'addedStateKeyToUser',
        state_key: stateKey,
    });
}
/**
 * @deprecated
 */
function track$1(eventName, eventData) {
    pushToDataLayer({
        event: eventName,
        ...eventData,
    });
}
/**
 * @deprecated
 */
function viewPage(pathname) {
    pushToDataLayer({
        event: 'simulatePageView',
        pathname,
    });
}
const getGlobalCustomerJourney = (customerJourney) => {
    if (customerJourney) {
        return customerJourney;
    }
    // @ts-expect-error window could be undefined and hence returning undefined for this function
    return window && lodashGet(window, CUSTOMERJOURNEY_STORAGE_KEY);
};

var GoogleTagManager_tracking = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CUSTOMERJOURNEY_STORAGE_KEY: CUSTOMERJOURNEY_STORAGE_KEY,
    identify: identify$1,
    identifyUser: identifyUser,
    initialize: initialize$1,
    track: track$1,
    trackClick: trackClick,
    trackError: trackError,
    trackEvent: trackEvent,
    trackForm: trackForm,
    trackFormField: trackFormField,
    trackModal: trackModal,
    trackSlider: trackSlider,
    viewPage: viewPage
});

function getDeviceCategory() {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'Tablet';
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return 'Mobile';
    }
    else {
        return 'Desktop';
    }
}

const AMPLITUDE_API_KEY = 'c8deac245de40e642fe0dbb2bbb0d2d2';
const isDevelopmentEnvironment = process.env.NODE_ENV === 'development';
function logDevelopmentErrors(functionName, args) {
    const isStagingEnvironment = lodashGet(window, 'STAGING_ENVIRONMENT') === true;
    if (!isDevelopmentEnvironment && !isStagingEnvironment)
        return;
    return console.error(`${functionName} could not be called with arguments:`, Array.from(args));
}
function initialize() {
    if (!getSessionId() && typeof window !== 'undefined') {
        init(AMPLITUDE_API_KEY);
    }
}
function identify(stateKey) {
    if (getSessionId() && !isDevelopmentEnvironment) {
        if (typeof window !== 'undefined') {
            // Set user properties used across all repos here
            setUserProperty('Domain country', getDomainCountry());
            setUserProperty('Device category', getDeviceCategory());
        }
        if (stateKey) {
            setUserId(stateKey);
        }
    }
    else {
        // eslint-disable-next-line prefer-rest-params
        return logDevelopmentErrors('amplitude.getInstance().setUserId', arguments);
    }
}
function setUserProperty(property, propertyValue) {
    if (getSessionId() && !isDevelopmentEnvironment) {
        const identify = new Identify().set(property, propertyValue);
        identify$2(identify);
    }
}
function track({ category, event, payload }) {
    if (getSessionId() && !isDevelopmentEnvironment) {
        const eventProperties = {
            category,
            pageName: (document && document.title) || '',
            url: (window && window.location && window.location.pathname) || '',
            ...payload,
        };
        Object.keys(eventProperties).forEach((key) => eventProperties[key] === undefined ? delete eventProperties[key] : {});
        logEvent(event, eventProperties);
    }
    else {
        // eslint-disable-next-line prefer-rest-params
        return logDevelopmentErrors('amplitude.getInstance().logEvent', arguments);
    }
}
const Amplitude = {
    initialize,
    identify,
    track,
    setUserProperty,
};

/**
 * @deprecated
 */
const EVENT_NAMES$1 = {
    LATEST_SIGNUP_STEP: 'loaded',
    COMPLETE_SIGNUP_STEP: 'completed',
    ACCEPT_OFFER: 'Offer selected',
    INSTANT_DECISION_CTA_CLICKED: 'Instant decision CTA clicked',
    DOCUMENTS_UPLOADED: 'Documents Uploaded',
    PAGE_VISITED: 'Signup Visited',
};
const CATEGORY$1 = {
    SIGNUP: 'Signup',
    SIGNUP_DE: 'Signup DE',
};
/**
 * @deprecated
 */
const SIGNUP_STEPS_HUMANISED = [
    'Step Zero',
    'Business details',
    'Personal details',
    'Trading details',
    'My Account',
];
/**
 * @deprecated
 */
function getLatestSignupStepEventProperties(signupStep, locale) {
    const event = `${signupStep} ${EVENT_NAMES$1.LATEST_SIGNUP_STEP}`;
    return {
        event,
        category: locale?.toLowerCase() === 'de' ? CATEGORY$1.SIGNUP_DE : CATEGORY$1.SIGNUP,
    };
}
/**
 * @deprecated
 */
function getCompletedSignupStepEventProperties(signupStep, locale) {
    const event = `${signupStep} ${EVENT_NAMES$1.COMPLETE_SIGNUP_STEP}`;
    return {
        event,
        category: locale?.toLowerCase() === 'de' ? CATEGORY$1.SIGNUP_DE : CATEGORY$1.SIGNUP,
    };
}
/**
 * @deprecated
 */
function getInstantDecisionEventProperties(suggestedProduct, requestedProductType, locale) {
    return {
        category: locale?.toLowerCase() === 'de' ? CATEGORY$1.SIGNUP_DE : CATEGORY$1.SIGNUP,
        event: EVENT_NAMES$1.INSTANT_DECISION_CTA_CLICKED,
        payload: {
            suggestProductType: suggestedProduct,
            requestedProductType,
        },
    };
}
/**
 * @deprecated
 */
function getDocumentsUploadedEventProperties(suggestedProduct, locale) {
    return {
        category: locale?.toLowerCase() === 'de' ? CATEGORY$1.SIGNUP_DE : CATEGORY$1.SIGNUP,
        event: EVENT_NAMES$1.DOCUMENTS_UPLOADED,
        payload: {
            suggestProductType: suggestedProduct,
        },
    };
}
/**
 * @deprecated
 */
function signupEventCreator({ event, payload, locale, }) {
    return {
        event: event,
        category: locale?.toLowerCase() === 'de' ? CATEGORY$1.SIGNUP_DE : CATEGORY$1.SIGNUP,
        payload: {
            ...(payload || {}),
        },
    };
}
/**
 * @deprecated
 */
function getPageVisitedEvent$1() {
    return {
        category: CATEGORY$1.SIGNUP,
        event: EVENT_NAMES$1.PAGE_VISITED,
    };
}
/**
 * @deprecated
 */
const ACCEPT_OFFER_LIGHTING_LOAN = {
    category: CATEGORY$1.SIGNUP,
    event: EVENT_NAMES$1.ACCEPT_OFFER,
    payload: {
        offerType: 'Lighting Loan',
    },
};
/**
 * @deprecated
 */
const ACCEPT_OFFER_RLS = {
    category: CATEGORY$1.SIGNUP,
    event: EVENT_NAMES$1.ACCEPT_OFFER,
    payload: {
        offerType: 'Recovery Loan',
    },
};
/**
 * @deprecated
 */
const ACCEPT_OFFER_INDICATIVE = {
    category: CATEGORY$1.SIGNUP,
    event: EVENT_NAMES$1.ACCEPT_OFFER,
    payload: {
        offerType: 'Indicative Offer',
    },
};

var Amplitude_signup = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ACCEPT_OFFER_INDICATIVE: ACCEPT_OFFER_INDICATIVE,
    ACCEPT_OFFER_LIGHTING_LOAN: ACCEPT_OFFER_LIGHTING_LOAN,
    ACCEPT_OFFER_RLS: ACCEPT_OFFER_RLS,
    EVENT_NAMES: EVENT_NAMES$1,
    SIGNUP_STEPS_HUMANISED: SIGNUP_STEPS_HUMANISED,
    getCompletedSignupStepEventProperties: getCompletedSignupStepEventProperties,
    getDocumentsUploadedEventProperties: getDocumentsUploadedEventProperties,
    getInstantDecisionEventProperties: getInstantDecisionEventProperties,
    getLatestSignupStepEventProperties: getLatestSignupStepEventProperties,
    getPageVisitedEvent: getPageVisitedEvent$1,
    signupEventCreator: signupEventCreator
});

/**
 * @deprecated
 */
const CATEGORY = {
    WEBSITE: 'Website',
};
/**
 * @deprecated
 */
const EVENT_NAMES = {
    OPEN_APPLICATION_MODAL: 'Application modal opened',
    FAQ_OPENED: 'FAQ opened',
    START_APPLICATION: `Application started`,
    PAGE_VISITED: 'Website Visited',
};
/**
 * @deprecated
 */
const START_APPLICATION = {
    category: CATEGORY.WEBSITE,
    event: EVENT_NAMES.START_APPLICATION,
};
/**
 * @deprecated
 */
const OPEN_STEP_0_MODAL = {
    category: CATEGORY.WEBSITE,
    event: EVENT_NAMES.OPEN_APPLICATION_MODAL,
};
/**
 * @deprecated
 */
const OPEN_CALCULATOR_STEP_0_MODAL = {
    ...OPEN_STEP_0_MODAL,
    payload: {
        ctaSource: 'Calculator',
    },
};
/**
 * @deprecated
 */
const OPEN_HEADER_STEP_0_MODAL = {
    ...OPEN_STEP_0_MODAL,
    payload: {
        ctaSource: 'Header',
    },
};
/**
 * @deprecated
 */
const OPEN_FOOTER_STEP_0_MODAL = {
    ...OPEN_STEP_0_MODAL,
    payload: {
        ctaSource: 'Footer',
    },
};
/**
 * @deprecated
 */
const OPEN_HERO_BANNER_STEP_0_MODAL = {
    ...OPEN_STEP_0_MODAL,
    payload: {
        ctaSource: 'Hero Banner',
    },
};
/**
 * @deprecated
 */
const OPEN_NAV_STEP_0_MODAL = {
    ...OPEN_STEP_0_MODAL,
    payload: {
        ctaSource: 'Nav Bar CTA',
    },
};
/**
 * @deprecated
 */
const OPEN_QUESTIONS_STEP_0_MODAL = {
    ...OPEN_STEP_0_MODAL,
    payload: {
        ctaSource: 'Questions CTA',
    },
};
/**
 * @deprecated
 */
const GET_STARTED_STEP_0_MODAL = {
    ...OPEN_STEP_0_MODAL,
    payload: {
        ctaSource: 'Get started CTA',
    },
};
/**
 * @deprecated
 */
function getPageVisitedEvent() {
    return {
        category: CATEGORY.WEBSITE,
        event: EVENT_NAMES.PAGE_VISITED,
    };
}
/**
 * @deprecated
 */
function getStep0ModalEventWithProductTypeAndText(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
event, ctaText, productType) {
    return {
        ...event,
        payload: {
            ...event.payload,
            ctaText,
            productType,
        },
    };
}
/**
 * @deprecated
 */
function getFaqClicked(faqText) {
    return {
        category: CATEGORY.WEBSITE,
        event: EVENT_NAMES.FAQ_OPENED,
        payload: {
            faqText: faqText,
        },
    };
}

var Amplitude_website = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CATEGORY: CATEGORY,
    EVENT_NAMES: EVENT_NAMES,
    GET_STARTED_STEP_0_MODAL: GET_STARTED_STEP_0_MODAL,
    OPEN_CALCULATOR_STEP_0_MODAL: OPEN_CALCULATOR_STEP_0_MODAL,
    OPEN_FOOTER_STEP_0_MODAL: OPEN_FOOTER_STEP_0_MODAL,
    OPEN_HEADER_STEP_0_MODAL: OPEN_HEADER_STEP_0_MODAL,
    OPEN_HERO_BANNER_STEP_0_MODAL: OPEN_HERO_BANNER_STEP_0_MODAL,
    OPEN_NAV_STEP_0_MODAL: OPEN_NAV_STEP_0_MODAL,
    OPEN_QUESTIONS_STEP_0_MODAL: OPEN_QUESTIONS_STEP_0_MODAL,
    OPEN_STEP_0_MODAL: OPEN_STEP_0_MODAL,
    START_APPLICATION: START_APPLICATION,
    getFaqClicked: getFaqClicked,
    getPageVisitedEvent: getPageVisitedEvent,
    getStep0ModalEventWithProductTypeAndText: getStep0ModalEventWithProductTypeAndText
});

export { Amplitude, pandora as AmplitudePandora, Amplitude_signup as AmplitudeSignup, Amplitude_website as AmplitudeWebsite, Events, GoogleTagManager_tracking as GoogleTagManager, tracking };
//# sourceMappingURL=index-es.js.map
